import { allReportsEn } from './all-reports.js';
import { attachmentPreviewEn } from './attachment-preview.js';
import { cashEn } from './cash.js';
import { charterPartiesEn, cpAnalysisEn, voyageReferenceEn } from './charter-party.js';
import { classIntegrationEn } from './class-integration.js';
import { crewListEn } from './crew-list.js';
import { crewNotesEn } from './crew-notes.js';
import { crewProfileEn } from './crew-profile.js';
import { dailyEn } from './daily.js';
import { defectsEn } from './defects.js';
import { documentsEn } from './documents.js';
import { drillFindingEn } from './drill-finding.js';
import { drillPlanEn } from './drill-plan.js';
import { drillRecordEn } from './drill-record.js';
import { drillReportEn } from './drill-report.js';
import { drillsEn } from './drills.js';
import { drydockEn } from './drydock.js';
import { drydockAuditEn, drydockFleetEn, drydockReportEn } from './drydock-report.js';
import { formsEn } from './forms.js';
import { fuelEn } from './fuel.js';
import { fuelAnalysisEn, voyageCardsEn } from './fuel-analysis.js';
import { helpEn, pageHelpEn } from './help.js';
import { hseEn } from './hse.js';
import { companyNcEn, hseExtraEn, portCallPdfEn, recordPdfEn } from './hse-m15g.js';
import { loginAccountsEn } from './login-accounts.js';
import { masterSectionEn } from './master-section.js';
import { materialsEn, stockEn } from './materials.js';
import { officePackEn } from './office-pack.js';
import { payrollEn } from './payroll.js';
import { pmsEn } from './pms.js';
import { pmsAuditEn } from './pms-audit.js';
import { pmsLibraryEn } from './pms-library.js';
import { pmsReportsEn } from './pms-reports.js';
import { portCallsEn } from './port-calls.js';
import { portsEn } from './ports.js';
import { provisionsEn } from './provisions.js';
import { purchasingEn } from './purchasing.js';
import { purchasingMarketEn } from './purchasing-market.js';
import { purchasingShipEn } from './purchasing-ship.js';
import { reportsEn } from './reports.js';
import { returnedEn } from './returned.js';
import { riskEn } from './risk.js';
import { riskDashboardEn } from './risk-dashboard.js';
import { riskFindingsEn } from './risk-findings.js';
import { riskLibraryEn } from './risk-library.js';
import { riskMasterEn } from './risk-master.js';
import { riskRegisterEn } from './risk-register.js';
import { riskVerificationEn } from './risk-verification.js';
import { settingsEn } from './settings.js';
import { setupEn } from './setup.js';
import { restHoursClockEn, shipClockEn } from './ship-clock.js';
import { signOnOffEn } from './sign-on-off.js';
import { supplierAccountEn } from './supplier-account.js';
import { supplierNoticesEn } from './supplier-notices.js';
import { supplierProfileEn } from './supplier-profile.js';
import { tasksEn } from './tasks.js';
import { testAccountsEn } from './test-accounts.js';
import { vesselCertificatesEn } from './vessel-certificates.js';
import { victuallingEn } from './victualling.js';
import { voyageContextEn } from './voyage-context.js';
import { voyageLinksEn } from './voyage-links.js';
import { voyageRecordEn } from './voyage-record.js';

/**
 * Ortak kabuk, menü ve ortak ekran metinleri: İngilizce (varsayılan; CLAUDE.md "i18n").
 * Menü adları tasarımdaki gibidir (`docs/ekranlar/menu-yapisi.md`).
 */
export const en = {
  menu: {
    dashboard: 'Dashboard',
    fleet: 'Fleet',
    fleetVessels: 'Vessels',
    voyage: 'Voyage',
    // Voyage alt grupları (ADR 0082; ortağın sefer-1, sefer-6)
    voyageReports: 'Reports',
    voyageReportsAll: 'All Reports',
    voyageReportsArrival: 'Arrival Report',
    voyageReportsDailyPort: 'Daily Port Report',
    voyageReportsDeparture: 'Departure Report',
    voyageReportsAnchoring: 'Anchoring Report',
    voyageReportsAnchorAweigh: 'Anchor Aweigh Report',
    voyageReportsDrifting: 'Drifting Report',
    voyageReportsDriftDeparture: 'Drift Departure Report',
    voyageReportsCanalStrait: 'Canal / Strait Transit',
    voyageReportsNoon: 'Noon Report',
    voyageRecords: 'Voyage Reports',
    voyageList: 'Voyage List',
    voyageNew: 'Create New Voyage',
    voyageDetails: 'Voyage Details',
    voyageTimeline: 'Voyage Timeline',
    voyageSummary: 'Voyage Summary',
    voyageLegs: 'Leg / Event',
    voyageRoute: 'Route & Distances',
    voyageAnalysis: 'Performance & Analysis',
    voyageFuelAnalysis: 'Fuel & Consumption Analysis',
    voyageReference: 'Reference Data',
    voyageDistances: 'Port Distance Library',
    voyageReportTemplates: 'Report Templates',
    voyageEventTypes: 'Event Types',
    voyageNoonReport: 'Noon Report',
    voyagePerformance: 'Voyage Performance',
    voyageCharterParties: 'Charter Party Register',
    voyageCharterParty: 'Charter Party Performance',
    voyageCiiMrv: 'CII / MRV',
    crew: 'Crew',
    crewList: 'Crew List',
    crewLists: 'Crew Lists (FAL 5)',
    crewCertificates: 'Certificates & Documents',
    crewTraining: 'Training & Courses',
    crewSignOnOff: 'Sign On / Off',
    crewLoginAccounts: 'Login Accounts',
    crewCalendar: 'Crew Calendar',
    crewRestHours: 'Hours of Work & Rest',
    crewShipClock: "Ship's Clock Log",
    crewPayroll: 'Payroll',
    crewPayrollMonthly: 'Monthly Payroll',
    crewPayrollAdvances: 'Advances & Deductions',
    crewPayrollAllotments: 'Allotment',
    crewPayrollPayslips: 'Payslip Generator',
    crewPayrollPayments: 'Payment Register',
    crewPayrollClosing: 'Monthly Closing',
    crewPayrollReports: 'Payroll Reports',
    operations: 'Operations',
    operationsDailyPlan: 'Daily Works Plan',
    operationsDailyReports: 'Daily Reports',
    operationsPortCalls: 'Port Calls',
    operationsDrills: 'Drills',
    operationsDrillsDashboard: 'Dashboard',
    operationsDrillsPlanner: 'Planner',
    operationsDrillsRecords: 'Records',
    operationsDrillsCompetency: 'Crew Competency',
    operationsDrillsAnalytics: 'Analytics',
    operationsDrillsLibrary: 'Library',
    compliance: 'Compliance',
    complianceIsmForms: 'ISM Forms',
    complianceIsmFormList: 'Form List',
    complianceIsmFormCategories: 'Form Categories',
    complianceIsmFormHistory: 'Form History',
    complianceManuals: 'Manuals',
    complianceVesselCertificates: 'Vessel Certificates',
    // HSEQ Reports alt grubu (ADR 0097 Ek): All Reports ve türler
    complianceHseqReports: 'HSEQ Reports',
    complianceHseq: 'All Reports',
    complianceDeficiency: 'Deficiency',
    complianceNonConformity: 'Non-Conformity',
    complianceAccident: 'Accident',
    complianceNearMiss: 'Near Miss',
    complianceRisk: 'Risk Assessment',
    complianceRiskDashboard: 'Dashboard',
    complianceRiskAssessment: 'Risk Assessments',
    complianceRiskLibrary: 'Library',
    complianceRiskRegister: 'Vessel Risk Register',
    complianceRiskVerification: 'Operational Verification',
    complianceRiskFindings: 'Findings & Actions',
    complianceRiskReports: 'Monitoring & Reports',
    complianceRiskMasterData: 'Master Data',
    materialMaster: 'Material Master',
    purchasing: 'Purchasing',
    purchasingRequisitions: 'Material Requisition',
    purchasingRfq: 'RFQ',
    purchasingOrders: 'Purchase Orders',
    purchasingSuppliers: 'Suppliers',
    purchasingGrn: 'GRN',
    purchasingStock: 'Stock Management',
    inventory: 'Inventory',
    inventorySpareParts: 'Spare Parts',
    inventoryStock: 'Stock In / Out',
    inventoryProvision: 'Provision',
    inventoryVictualling: 'Victualling Report',
    pms: 'Maintenance (PMS)',
    pmsEquipment: 'Equipment List',
    pmsPlan: 'Maintenance Plan',
    pmsPostponements: 'Postponements',
    pmsWorkOrders: 'Work Orders',
    pmsDefects: 'Defects',
    pmsLibrary: 'PMS Library',
    pmsClassIntegration: 'Class Integration',
    pmsHistory: 'History',
    pmsDrydock: 'Dry Docking',
    pmsDrydockProjects: 'Projects',
    pmsDrydockInspection: 'Pre-Docking Inspection',
    pmsDrydockFleet: 'Fleet Overview',
    pmsDrydockJobs: 'Yard Job List',
    pmsDrydockLibrary: 'Inspection Library',
    // Yakıt yönetimi (ADR 0117 §14; ortağın tasarımı 01–07)
    fuelManagement: 'Fuel Management',
    // Finance & Cash Management (ADR 0093; ortağın kasa.pdf §1)
    finance: 'Finance',
    financeCtm: 'Cash to Master (CTM)',
    financeCashAccounts: 'Cash Accounts',
    financeCtmRequests: 'CTM Requests',
    financeCtmApprovals: 'CTM Approvals & Transfers',
    financeCtmReceipts: 'CTM Receipt Confirmation',
    financeCtmHistory: 'CTM History',
    financeCash: 'Cash Account',
    financeCashTransactions: 'Cash Transactions',
    financeCashBalances: 'Cash Balance by Currency',
    financeCashReconciliation: 'Cash Reconciliation',
    financeCashMonthly: 'Monthly Cash Report',
    financeReports: 'Finance Reports',
    reports: 'Reports',
    settings: 'Settings',
  },
  shell: {
    mainMenu: 'Main menu',
    toggleMenu: 'Toggle menu',
    closeMenu: 'Close menu',
    expand: 'Expand {{name}}',
    search: 'Search vessel, voyage, port…',
    searchLabel: 'Search',
    searchEmpty: 'No results',
    searchModules: 'Modules',
    notifications: 'Notifications',
    notificationsCount_one: 'Notifications, {{count}} new',
    notificationsCount_other: 'Notifications, {{count}} new',
    notificationsEmpty: 'No new notifications.',
    userMenu: 'User menu',
    language: 'Language',
    signOut: 'Sign out',
    breadcrumb: 'Breadcrumb',
    defaultTagline: 'Ship & Office Management',
    sloganTitle: 'Safe Crew',
    sloganSubtitle: 'Safe Voyage',
    vesselLabel: 'Vessel',
    imo: 'IMO {{imo}}',
    selectVessel: 'Select vessel',
    home: 'Home',
    skipToContent: 'Skip to content',
    officeUser: 'Office',
  },
  /** Ortak metinler (M6f G1): boş, hata ve yükleniyor durumları, tarih girişleri, onaylar. */
  /** Onayda parola (ADR 0056): parolasız onayın bilgi metni ve Ayarlar ▸ Onaylar. */
  approvalPolicy: {
    note: 'You are approving this record; your approval carries a digest (hash) of its content.',
    settings: {
      title: 'Approvals',
      text: 'Password re-entry on approval. By default no approval asks for the password again: the user is already signed in with their own password and confirms each approval with an explicit approve step. Turn the setting on to ask for the password on every approval and acknowledgement.',
      reauthAlways: 'Ask for the password on every approval',
      reauthAlwaysHint:
        'When on, every approval and acknowledgement asks for the password again. The setting reaches the vessels with the next sync.',
      saved: 'Saved.',
      save: 'Save',
      error: 'The setting could not be saved.',
      retry: 'Try again',
    },
  },
  common: {
    retry: 'Try again',
    // Sayfanın okuması yetkisiz döndü (ADR 0067 §6)
    accessDenied: {
      title: 'You do not have permission to view this page.',
      description: 'Ask your company administrator for access.',
    },
    clearFilters: 'Clear filters',
    noData: 'No data',
    loadError: 'The data could not be loaded.',
    view: 'View',
    clearDate: 'Clear date',
    datePlaceholder: 'DD.MM.YYYY',
    dateTimePlaceholder: 'DD.MM.YYYY HH:mm',
    // LT + UTC zaman girişi (ADR 0057 §2)
    time: {
      lt: 'LT',
      utc: 'UTC',
      ltZone: 'LT ({{zone}})',
      entryMode: 'Enter {{field}} in LT or UTC',
      offsetGroup: 'UTC offset',
      zoneGroup: 'Time zone (offset at report time)',
    },
    hours: 'Hours',
    minutes: 'Minutes',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    apply: 'Apply',
    /** Konum kutuları (ADR 0054 §3): derece, dakika, yön. */
    position: {
      degrees: '{{label}} degrees',
      minutes: '{{label}} minutes',
      hemisphere: '{{label}} direction',
    },
    unsaved: {
      title: 'Discard unsaved changes?',
      message: 'Your changes on this page have not been saved. If you leave, they will be lost.',
      stay: 'Stay',
      discard: 'Discard',
    },
  },
  comingSoon: {
    badge: 'Being prepared',
    title: 'This module is being prepared',
    planned: 'Planned for {{stage}}',
    back: 'Back to Dashboard',
    reference:
      'The screen follows the approved design and arrives in both the vessel app and the office.',
    officeBadge: 'Office',
    officeTitle: 'This screen is used in the office',
    officeNote:
      'Suppliers, requests for quotation and quotations are commercial data of the office; they do not reach the vessel. Requisitions and their approvals are followed under Material Requisition.',
    modules: {
      voyageList: 'All voyages of the vessel with their legs, events and status.',
      voyageNew:
        'Create a voyage with planned charter party speed, consumption and weather limits.',
      voyageLegs: 'Departure, Noon, COSP, EOSP and Arrival events of each leg.',
      voyageRoute: 'Ports of the voyage with leg distances and a port order suggestion.',
      voyageDistances: 'Port-to-port distance table of the company and company ports.',
      voyageNoonReport:
        'Daily noon report: position, distance and speed, machinery, fuel and ROB, weather and sea.',
      voyagePerformance: 'Speed, consumption and time against the voyage plan.',
      voyageCharterParties:
        'Charter parties of the vessel: terms, delivery and redelivery, passages outside a charter.',
      voyageCharterParty: 'Charter party speed and consumption performance with weather limits.',
      voyageCiiMrv: 'EU MRV, IMO DCS and CII reporting.',
      voyageDetails:
        'Voyage record: linked reports, events, leg distances, fuel consumption and voyage periods.',
      voyageTimeline:
        'Horizontal timeline of the voyage: events, legs and distances, port and anchorage times.',
      voyageSummary:
        'Sailing, port, anchorage and drift time, distance and consumption, derived from the reports.',
      voyageFuelAnalysis:
        'Consumption by fuel type at sea, in port, at anchor and drifting, with daily average and bunkering.',
      voyageReportTemplates:
        'Catalogue of the voyage report types with their sections and required fields.',
      voyageEventTypes:
        'Events recorded in the reports (EOSP, COSP, Pilot On / Off, NOR, First Line, All Fast …) with their source report and field.',
      crewList: 'Crew on board and ashore with rank, vessel and dates.',
      crewLists:
        'IMO FAL Form 5 crew lists for arrival and departure, prepared from the crew on board.',
      crewCertificates: 'Crew certificates and documents with validity tracking.',
      crewTraining: 'Training needs from drill findings and how they were met.',
      pmsDrydockFleet:
        'Dry docking projects of the fleet: inspections, jobs awaiting the office, yard progress and verification (office only).',
      operationsDrillsAnalytics:
        'Fleet drill analytics: completion rate, delays, muster and response time trends.',
      crewSignOnOff: 'Joining and sign-off records.',
      crewLoginAccounts:
        'Login e-mails and passwords of the crew and office, managed in the office (office only).',
      crewCalendar: 'Crew rotation and leave calendar.',
      crewRestHours: 'Hours of work and rest with MLC 2006 and STCW checks.',
      operationsDailyPlan: 'Daily works plan by department.',
      operationsDailyReports: 'Daily reports from each department.',
      operationsPortCalls: 'Port calls, agents and port activities.',
      complianceIsmFormList:
        'ISM forms of the company library: preview, information and revisions.',
      complianceIsmFormCategories: 'Form categories as folders of the form tree.',
      complianceIsmFormHistory: 'Filled forms with their approvals and history.',
      complianceManuals: 'Company manuals with controlled revisions and acknowledgement on board.',
      complianceVesselCertificates:
        'Statutory, class and flag certificates with surveys and due dates.',
      complianceHseq:
        'Non-conformities, deficiencies, near misses and accidents in one place, in four stages.',
      complianceDeficiency: 'Deficiencies with corrective actions and close-out.',
      complianceNonConformity: 'Non-conformities after audits and PSC inspections.',
      complianceAccident: 'Accident reports and investigations.',
      complianceNearMiss: 'Near miss reports and lessons learned.',
      complianceRisk: 'Risk assessments and the company risk library.',
      complianceRiskAssessment: 'Risk assessments with the 5×5 matrix and control measures.',
      complianceRiskLibrary:
        'Company risk assessments: Builder, review, approval, published versions and vessel assignment.',
      complianceRiskRegister:
        'Company risk assessments assigned to the vessel, their review dates and acknowledgement on board.',
      complianceRiskVerification:
        'Verify a planned operation against the current risk assessment and authorise it before work starts.',
      complianceRiskFindings:
        'Findings from operational verifications: corrective actions, reverification, company escalation and closure.',
      complianceRiskMasterData:
        'Company risk library: activities, hazards, controls and risk rows; Excel import.',
      complianceRiskDashboard:
        'Risk summary: acknowledgements, reviews due, operations awaiting authorisation, high residual risks and stopped work.',
      complianceRiskReports:
        'Library status, register compliance and verification history with CSV export.',
      materialMaster: 'Material catalogue with categories, codes and related equipment.',
      purchasingRequisitions: 'Material requisitions from the vessel with approval flow.',
      purchasingRfq: 'Requests for quotation and supplier comparison.',
      purchasingOrders: 'Purchase orders and their status.',
      purchasingSuppliers: 'Supplier list and performance.',
      purchasingGrn: 'Delivery and goods received notes.',
      purchasingStock: 'Stock on hand with minimum and maximum levels.',
      inventorySpareParts: 'Spare parts, consumables and stores on board; provisions excluded.',
      inventoryStock: 'Stock in and out movements on board.',
      inventoryProvision: 'Provisions and their consumption.',
      inventoryVictualling: 'Monthly victualling report and rate per person-day.',
      pmsEquipment: 'Equipment tree, components and counters.',
      pmsPlan: 'Planned maintenance jobs and intervals.',
      pmsPostponements: 'Postponed jobs: Master approval on board, office monitoring.',
      pmsWorkOrders: 'Work orders with reporting and approvals.',
      pmsDefects: 'Defect reports (DM-17): notification, rectification and sign-off.',
      pmsLibrary:
        'Company library of equipment and maintenance jobs; applied to vessels from the office.',
      pmsClassIntegration:
        'Daily transfer of completed maintenance records to DNV (MAD), mapping and validation.',
      pmsHistory: 'Maintenance history and NR496 reports.',
      fuelManagement: 'Fuel tanks, bunkering, transfers, consumption, ROB and MRV / ETS.',
      reports: 'Reports of each module, printable and exportable.',
    },
  },
  alerts: {
    title: 'Active Alerts',
    none: 'No active alerts.',
    certificate: {
      expired: '{{certificate}} expired',
      expiring: '{{certificate}} expires soon',
      expiresIn_one: '{{certificate}} expires in {{count}} day',
      expiresIn_other: '{{certificate}} expires in {{count}} days',
      expiresToday: '{{certificate}} expires today',
    },
    missing_one: '{{count}} required certificate missing',
    missing_other: '{{count}} required certificates missing',
    rest: {
      violation: 'Hours of rest below MLC limits',
      warning: 'Hours of rest close to MLC limits',
    },
    // Gemi saati (ADR 0065 §5)
    clock: {
      upcoming: "Ship's clocks {{change}} at {{time}} ({{from}} → {{to}})",
      pending: "Clock change awaits the master's approval: {{change}} at {{time}}",
    },
    // Kontrat / MLC (ADR 0076 §4) [MLC 2006 Std A2.5.1 §2(b)]
    contract: {
      contract: {
        in_one: 'Contract ends in {{count}} day',
        in_other: 'Contract ends in {{count}} days',
        today: 'Contract ends today',
        overdue: 'Contract ended, still on board',
      },
      mlc: {
        in_one: 'MLC 12-month limit in {{count}} day',
        in_other: 'MLC 12-month limit in {{count}} days',
        today: 'MLC 12-month limit today',
        overdue: 'MLC 12-month limit exceeded',
      },
    },
    // Tatbikat (ADR 0128 Faz 2 Ek; ADR 0156 hata düzeltmesi)
    drill: {
      overdue: '{{drill}} drill is overdue',
      due: '{{drill}} drill is due',
      pending_review: '{{drill}} drill awaits review',
      postponement: '{{drill}} drill postponement requested',
    },
  },
  overview: {
    certificates: 'Certificate Overview',
    total: 'Total',
    valid: 'Valid',
    expiring: 'Expiring',
    expired: 'Expired',
    missing: 'Missing',
    rest: 'Hours of Rest',
    restOn: 'Hours of rest on {{date}}',
    compliant: 'Compliant',
    warning: 'Warning',
    violation: 'Violation',
    incomplete: 'Not recorded',
    expirations: {
      title: 'Upcoming Expirations',
      name: 'Name',
      document: 'Document',
      expiry: 'Expiry Date',
      viewAll: 'View All',
      none: 'No certificates expiring soon.',
    },
  },
  crew: {
    title: 'Crew List',
    subtitle: 'Crew on board and ashore with rank, vessel and dates.',
    subtitleShip: 'Crew currently on board {{vessel}}.',
    summary: {
      label: 'Crew summary',
      total: 'Total crew',
      onBoard: 'On board',
      ashore: 'Ashore',
      longAshore: 'Ashore {{days}}+ days',
    },
    filters: 'Crew filters',
    vessel: 'Vessel',
    allVessels: 'All Vessels',
    rank: 'Rank',
    allRanks: 'All Ranks',
    filter: {
      label: 'Status',
      all: 'All Statuses',
      on_board: 'On Board',
      ashore: 'Ashore',
      not_assigned: 'Not assigned',
    },
    search: 'Search crew...',
    add: 'Add Crew',
    columns: {
      photo: 'Photo',
      name: 'Name',
      rank: 'Rank',
      nationality: 'Nationality',
      status: 'Status',
      vessel: 'Vessel',
      since: 'Since',
      days: 'Duration',
      next: 'Next joining',
      contract: 'Contract end',
      login: 'Login',
      actions: 'Actions',
    },
    // "Login" sütunu ve süzgeci (ortak 2026-10-30)
    login: {
      label: 'Login',
      login: 'Login',
      none: 'No login',
      disabled: 'Disabled',
      filter: { all: 'All logins', no_login: 'No login' },
    },
    // Kontrat bitişi ve kalan gün rozeti (ADR 0076 §5)
    contract: {
      left_one: '{{count}} day left',
      left_other: '{{count}} days left',
      today: 'Ends today',
      overdue_one: 'Ended {{count}} day ago',
      overdue_other: 'Ended {{count}} days ago',
      mlcOverdue_one: 'MLC limit +{{count}} day',
      mlcOverdue_other: 'MLC limit +{{count}} days',
      mlcLimit: 'MLC limit {{date}}',
      noContract: 'Not entered',
      exceeds: 'Beyond the MLC 12-month limit',
    },
    sortBy: 'Sort by {{column}}',
    // Durum yazımı Crew List, Certificates ve MLC ekranlarında tek (M6f G2-06)
    status: { on_board: 'On Board', ashore: 'Ashore', not_assigned: 'Not assigned' },
    days_one: '{{count}} day',
    days_other: '{{count}} days',
    emptyTitle: 'No crew yet',
    emptyText: 'People assigned to your vessels will appear here.',
    emptyShip:
      'No one is assigned to this vessel today. Assignments are made by the office and arrive with the next sync.',
    noMatch: 'No crew match your filters.',
    noPreviousAssignment: 'No previous assignment',
    error: 'The crew list could not be loaded.',
    table: 'Crew list',
    pagination: 'Crew list pages',
    page: { first: 'First page', previous: 'Previous page', next: 'Next page', last: 'Last page' },
    showing: 'Showing {{from}} - {{to}} of {{total}}',
    actions: 'Actions for {{name}}',
    openProfile: 'Crew Profile',
    openProfileOf: 'Open the crew profile of {{name}}',
    openCertificates: 'Certificates & Documents',
    openRestHours: 'Hours of Work & Rest',
  },
  certificates: {
    title: 'Certificates & Documents',
    subtitle:
      'Manage crew certificates, track validity dates and ensure compliance with STCW and company requirements.',
    add: 'Add Certificate',
    filters: 'Certificate filters',
    vessel: 'Vessel',
    crewMember: 'Crew Member',
    allCrew: 'All Crew',
    certificate: 'Certificate',
    vessels: 'Vessels',
    ashore: 'Shore / Available',
    crewCount_one: '{{count}} crew',
    crewCount_other: '{{count}} crew',
    crewOn: 'Crew on {{vessel}}',
    crewAshore: 'Crew ashore',
    searchCrew: 'Search crew...',
    moreCrew_one: '{{count}} more crew',
    moreCrew_other: '{{count}} more crew',
    noCrew: 'No one in this group.',
    noCrewMatch: 'No crew match your search.',
    noCrewHint: 'No one is assigned to this vessel today.',
    choosePerson: 'Choose a person to see their certificates.',
    summary: {
      label: 'Certificate summary',
      total: 'Total Certificates',
      valid: 'Valid',
      expiring: 'Expiring (≤ {{days}} days)',
      expired: 'Expired',
      missing: 'Missing',
    },
    filter: {
      label: 'Status',
      all: 'All Status',
      valid: 'Valid',
      expiring: 'Expiring',
      expired: 'Expired',
      missing: 'Missing',
    },
    search: 'Search certificate name...',
    tabs: {
      label: 'Certificate views',
      matrix: 'Certificate Matrix',
      documents: 'Documents',
      employment: 'Employment & Sign Off',
      notes: 'Notes',
    },
    columns: {
      certificate: 'Certificate / Document',
      category: 'Category',
      number: 'No.',
      issued: 'Issue Date',
      expires: 'Expiry Date',
      status: 'Status',
      file: 'File',
      actions: 'Actions',
    },
    status: { valid: 'Valid', expiring: 'Expiring', expired: 'Expired', missing: 'Missing' },
    sortBy: 'Sort by {{column}}',
    category: {
      competency: 'Competency',
      gmdss: 'GMDSS',
      stcw_safety: 'STCW Safety',
      security: 'Security',
      medical: 'Medical',
      specialized: 'Specialized',
      personal: 'Personal',
      other: 'Other',
    },
    noFile: 'No file',
    noExpiry: 'No expiry',
    daysLeft_one: '{{count}} day left',
    daysLeft_other: '{{count}} days left',
    daysAgo_one: 'expired {{count}} day ago',
    daysAgo_other: 'expired {{count}} days ago',
    required: 'Required for this rank',
    showing: 'Showing {{from}} - {{to}} of {{total}} certificates',
    pagination: 'Certificate pages',
    page: { first: 'First page', previous: 'Previous page', next: 'Next page', last: 'Last page' },
    noMatch: 'No certificates match your filters.',
    emptyTitle: 'No certificates yet',
    emptyText: 'Add the first certificate for this person.',
    emptyShip: 'Certificates are recorded by the office and arrive with the next sync.',
    overview: 'Certificate Overview',
    categories: 'Certificate Categories',
    documentsTitle: 'No separate documents',
    documentsEmpty:
      'Passport, seaman’s book and other personal documents are listed in the certificate matrix. File attachments arrive with the next update.',
    notesEmpty: 'No notes for this crew member.',
    employment: {
      vessel: 'Vessel',
      rank: 'Rank',
      signOn: 'Sign On',
      signOff: 'Sign Off',
      days: 'Days on board',
      daysAshore: 'Days ashore',
      next: 'Next assignment',
    },
    details: {
      title: 'Crew Member Details',
      close: 'Close crew member details',
      open: 'Crew details',
      certificates: 'Certificates',
      documents: 'Documents',
      employment: 'Employment',
      list: 'Certificate Details',
      showAll: 'Show all certificates ({{count}})',
    },
    alerts: 'Alerts',
    alertExpiring_one: '{{count}} certificate is expiring within {{days}} days!',
    alertExpiring_other: '{{count}} certificates are expiring within {{days}} days!',
    alertExpired_one: '{{count}} certificate has expired!',
    alertExpired_other: '{{count}} certificates have expired!',
    alertMissing_one: '{{count}} required certificate is missing!',
    alertMissing_other: '{{count}} required certificates are missing!',
    alertNone: 'All certificates are valid.',
    alertAction: 'Please take action to ensure compliance.',
    actions: 'Actions for {{name}}',
    edit: 'Edit',
    remove: 'Remove',
    addMissing: 'Add',
    removeTitle: 'Remove certificate',
    removeText:
      '{{name}} will be removed from the list. The record and its history are kept for audit.',
    removeConfirm: 'Remove',
    error: 'Certificates could not be loaded.',
    form: {
      addTitle: 'Add certificate',
      editTitle: 'Edit certificate',
      person: 'For {{name}}',
      type: 'Certificate',
      typeRequired: 'Choose a certificate.',
      typePlaceholder: 'Choose a certificate',
      number: 'Certificate number',
      issuedOn: 'Issue date',
      expiresOn: 'Expiry date',
      expiresHint: 'Leave empty if the document does not expire.',
      issuedBy: 'Issued by',
      save: 'Save',
      cancel: 'Cancel',
    },
  },
  restHours: {
    // Gemi saati değişikliği (ADR 0065 §7)
    clock: restHoursClockEn,
    title: 'Hours of Work & Rest (MLC)',
    subtitle: 'Track working hours, rest periods and ensure compliance with MLC requirements.',
    vessel: 'Vessel',
    date: 'Date',
    dateCard: 'Selected day',
    previousDay: 'Previous day',
    nextDay: 'Next day',
    summary: {
      label: 'Compliance on {{date}}',
      total: 'Total Crew',
      compliant: 'Compliant',
      warning: 'Warning',
      violation: 'Violation',
      incomplete: 'Not recorded',
    },
    crewList: 'Crew List',
    searchCrew: 'Search crew...',
    noCrew: 'No crew on this vessel for the selected day.',
    noCrewMatch: 'No crew match your search.',
    choosePerson: 'Choose a person to see their monthly record.',
    noVessels: 'Add a vessel to see hours of work and rest.',
    status: {
      compliant: 'Compliant',
      warning: 'Warning',
      violation: 'Violation',
      incomplete: 'Not recorded',
    },
    today: 'Today',
    work: 'Work',
    rest: 'Rest',
    mlcStatus: 'MLC Status',
    rest24h: '24h Rest',
    rest7d: '7 Days Rest',
    requiredShort: '(Required)',
    required: 'Required',
    tabs: {
      label: 'Hours of work and rest views',
      daily: 'Daily Schedule',
      weekly: 'Weekly Overview',
      monthly: 'Monthly Calendar',
      certificates: 'Certificates',
      notes: 'Notes',
      // Dar şeritte (≈ 1280–1440 px) kısa ad; uzun ad erişilebilir ad olarak kalır (M6f G1d-3)
      short: {
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        certificates: 'Certificates',
        notes: 'Notes',
      },
    },
    view: 'View',
    view24: '24 Hours',
    timeline: 'Work and rest on {{date}}, ship time',
    segment: '{{kind}} {{from}}–{{to}} ({{duration}})',
    columns: {
      date: 'Date',
      start: 'Start',
      end: 'End',
      duration: 'Duration',
      activity: 'Activity',
      location: 'Location',
      note: 'Notes',
      work: 'Work',
      rest: 'Rest',
      rest7d: '7 Days Rest',
      rest24h: '24h Rest',
      status: 'Status',
    },
    activity: {
      watch: 'Normal Watch',
      anchor_watch: 'Anchor Watch',
      maneuvering: 'Maneuvering',
      port_operations: 'Port Operations',
      cargo: 'Cargo Operations',
      maintenance: 'Maintenance',
      drill: 'Drill',
      emergency: 'Emergency',
      other: 'Others',
      rest: 'Rest',
    },
    shortBreak: 'Short break — not counted as rest',
    now: 'Now (ship time)',
    periodsError: 'Work periods could not be loaded.',
    periodsTable: 'Work and rest periods',
    weeklyTable: 'Last 7 days',
    month: {
      previous: 'Previous month',
      next: 'Next month',
      table: 'Hours of work and rest, {{month}}',
      noWork: 'No work recorded',
      upcoming: 'Upcoming',
      band: 'Hours of work, ship time',
      empty: 'No hours recorded for {{month}}',
      emptyText: 'Days appear here once hours are recorded on board.',
      record: 'Record:',
      hash: 'Content hash {{hash}}',
      exception: 'Exception',
      exceptions_one: '{{count}} exception (MLC A2.3 §14) — signed by the master on approval',
      exceptions_other: '{{count}} exceptions (MLC A2.3 §14) — signed by the master on approval',
      signatures: 'Signatures',
      notSigned: 'Not signed yet. The month can be signed after it ends.',
      signed: 'Signed by {{name}} (revision {{revision}})',
      approved: 'Approved by {{name}}',
      returned: 'Returned by {{name}}',
      sign: 'Sign month',
      review: 'Review month',
      signTitle: 'Sign {{month}} — {{name}}',
      reviewTitle: 'Review {{month}} — {{name}}',
      signText: 'By signing you confirm that the hours of this month are correct (MLC A2.3 §12).',
      reviewText: 'Approve the record or return it with a reason.',
      decision: 'Decision',
      approve: 'Approve',
      return: 'Return',
      reason: 'Reason for returning',
      acknowledge_one: 'I sign the {{count}} exception of this month (MLC A2.3 §14).',
      acknowledge_other: 'I sign the {{count}} exceptions of this month (MLC A2.3 §14).',
      password: 'Password',
      confirm: 'Confirm',
      error: 'The monthly record could not be loaded.',
      status: {
        draft: 'Not signed',
        pending: 'Awaiting master',
        approved: 'Approved',
        returned: 'Returned',
        reapproval_pending: 'Changed — sign again',
      },
      errors: {
        INVALID_CREDENTIALS: 'The password is wrong.',
        REAUTHENTICATION_REQUIRED:
          'Your company asks for the password on every approval. Enter it.',
        TOO_MANY_ATTEMPTS: 'Too many attempts. Wait 15 minutes and try again.',
        CONTENT_CHANGED: 'The hours changed meanwhile. Close and review again.',
        MONTH_NOT_ENDED: 'The month can be signed after it ends.',
        ALREADY_SUBMITTED: 'This month is already signed.',
        NOT_PENDING: 'This month is not awaiting a decision.',
        NOT_APPROVER: 'Only the master approves this record.',
        RETURN_REASON_REQUIRED: 'Write the reason for returning.',
        EXCEPTIONS_NOT_ACKNOWLEDGED: 'Sign the exceptions of this month.',
        APPROVAL_RULE_MISSING:
          'The approval matrix has no rule for monthly records. Ask the office.',
        FORBIDDEN: 'You are not allowed to do this.',
      },
    },
    // Aylık kaydın PDF kopyası (ADR 0024 #12; ILO/IMO kayıt biçimi; MLC A2.3 §12)
    pdf: {
      download: 'Download PDF',
      print: 'Print',
      error: 'The PDF could not be created.',
      errors: {
        OPEN_FAILED:
          'No app for opening PDF files was found on this computer. Use “Download PDF” and print the file with another app or computer.',
        POPUP_BLOCKED:
          'The browser blocked the new tab. Allow pop-ups for this site, or use “Download PDF”.',
      },
      title: 'Record of hours of work and rest',
      subtitle: 'ILO/IMO format · MLC 2006 Standard A2.3 · STCW Code A-VIII/1',
      vessel: 'Name of ship',
      imo: 'IMO number',
      seafarer: 'Seafarer (full name)',
      rank: 'Position / rank',
      month: 'Month and year',
      timeZone: 'Ship time zone',
      status: 'Record status',
      day: 'Day',
      grid: 'Hours of work (shaded), ship time',
      periods: 'Work periods',
      work: 'Work',
      rest: 'Rest',
      rest24h: 'Rest in any 24 h',
      rest7d: 'Rest in any 7 days',
      remarks: 'Remarks',
      notRecorded: 'Not recorded',
      total: 'Monthly total',
      summary_one:
        '{{recorded}} days recorded · {{violations}} with violations · {{warnings}} with warnings · {{count}} exception',
      summary_other:
        '{{recorded}} days recorded · {{violations}} with violations · {{warnings}} with warnings · {{count}} exceptions',
      clockNotes: "Ship's clock changes",
      legend:
        'V = violation, W = warning, E = exception (MLC A2.3 §14), signed by the master. Limits: at least 10 h rest in any 24 h and 77 h in any 7 days; rest in no more than two periods, one of them at least 6 h; no more than 14 h between rest periods (MLC A2.3 §5–6; STCW A-VIII/1).',
      rules: {
        MIN_REST_24H: 'Rest in 24 h',
        MIN_REST_7D: 'Rest in 7 days',
        MAX_WORK_24H: 'Work in 24 h',
        MAX_WORK_7D: 'Work in 7 days',
        REST_PERIODS_MAX_TWO: 'Rest in more than two periods',
        REST_PERIOD_MIN_6H: 'No rest period of 6 h',
        REST_INTERVAL_MAX_14H: 'Interval between rest periods',
      },
      electronic: 'Signatures in Felixmate',
      seafarerSigned: 'Seafarer signed: {{name}}, {{at}} (revision {{revision}})',
      notSigned: 'Seafarer: not signed',
      masterApproved: 'Master approved: {{name}}, {{at}}',
      masterReturned: 'Master returned: {{name}}, {{at}}',
      notApproved: 'Master: not approved',
      earlier: 'refers to an earlier version of this record',
      hash: 'Content hash (SHA-256)',
      declaration:
        'I agree that this record is an accurate reflection of the hours of work or rest of the seafarer concerned.',
      masterBox: 'Master or person authorized by the master',
      seafarerBox: 'Seafarer',
      name: 'Name',
      signature: 'Signature',
      date: 'Date',
      copyNote: 'A copy of this record is to be given to the seafarer (MLC A2.3 §12).',
      footer: '{{name}} · {{month}} · Felixmate · generated {{at}} · page {{page}} / {{pages}}',
      fileName: 'hours-of-rest',
    },
    edit: {
      open: 'Edit',
      title: 'Daily Working & Rest Record',
      who: '{{name}} ({{rank}})',
      timePart: '{{field}} – {{part}}',
      add: 'Add period',
      addTitle: 'New work period',
      editTitle: 'Edit work period',
      nextDayHint: 'An end time before the start ends the next day',
      noteHint: 'Required for emergencies (MLC A2.3 §14)',
      lockedNoteHint: 'Required: the reason for correcting a signed month (MLC A2.3 §12)',
      save: 'Save',
      done: 'Done',
      close: 'Close',
      cancel: 'Cancel',
      actions: 'Actions',
      editPeriod: 'Edit {{from}}–{{to}}',
      removePeriod: 'Remove {{from}}–{{to}}',
      removeQuestion: 'Remove the period {{from}}–{{to}}? The record is kept for audit.',
      confirmRemove: 'Remove',
      previousDay: '(prev. day)',
      totalWork: 'Total Working Hours',
      totalRest: 'Total Rest Hours',
      lockedTitle: 'This month is signed.',
      lockedText:
        'Only the master can correct it, with the reason in the note; the month then needs approval again. Periods of a signed month cannot be removed.',
      lockedRemove: 'Periods of a signed month cannot be removed.',
      mlcNote:
        'Hours of work and rest are recorded under MLC 2006 Standard A2.3 and STCW A-VIII/1, in ship time.',
      errors: {
        END_NOT_AFTER_START: 'End must differ from the start.',
        TIME_SKIPPED: "This time was not lived: the ship's clocks were advanced.",
        FUTURE_DATE: 'Hours cannot be entered for the future.',
        EMERGENCY_REASON_REQUIRED: 'Write the reason for the emergency work.',
        OVERLAPPING_PERIODS: 'This period overlaps another work period.',
        NO_ASSIGNMENT: 'The person is not assigned to this vessel on that day.',
        MONTH_LOCKED: 'This month is signed. Ask the master to correct it.',
        MONTH_LOCK_REASON_REQUIRED:
          'This month is signed: write the reason for the correction in the note.',
        ROW_VERSION_CONFLICT: 'Someone else changed this period. Close and open again.',
        FORBIDDEN: 'You can only enter your own hours.',
        TOO_LONG: 'This text is too long.',
        VALIDATION_FAILED: 'Check the fields.',
        GENERIC: 'Something went wrong. Please try again.',
      },
    },
    readOnly: 'Hours are entered on board and arrive with the next sync.',
    certificatesTitle: 'Certificates are on their own screen',
    certificatesLink: 'Open certificates of {{name}}',
    certificatesText: 'See Crew › Certificates & Documents.',
    notesEmpty: 'No notes for this day.',
    limits: 'MLC Key Limits',
    limit: {
      minRest24h: 'Minimum Rest (24h)',
      maxWork24h: 'Maximum Work (24h)',
      minRest7d: 'Minimum Rest (7 days)',
      maxWork7d: 'Maximum Work (7 days)',
    },
    hoursValue: '{{hours}} hours',
    rulesLink: 'View MLC Rules',
    rulesText:
      'MLC 2006 Std A2.3 §5–6 and STCW A-VIII/1: at least 10 hours of rest in any 24 hours and 77 hours in any 7 days; rest in at most two periods, one at least 6 hours; no more than 14 hours between rest periods.',
    compliance: 'MLC Compliance',
    restIn24h: 'Rest (24h)',
    remaining: 'Remaining',
    weekSummary: '7 Day Summary',
    restPeriods: 'Rest Periods (24h)',
    noRestPeriods: 'No rest periods recorded',
    weekChart: '7 Day Work & Rest Summary',
    weekBar: '{{date}}: work {{work}}, rest {{rest}}',
    distribution: 'Work Type Distribution (7\u00a0Days)',
    totalWork: 'Total Work',
    noWork: 'No work recorded in the last 7 days.',
    logs: 'Recent Logs',
    logStart: 'Work period started - {{activity}}',
    logEnd: 'Work period ended - {{activity}}',
    logsEmpty: 'No records in the last 7 days.',
    incompleteTitle: 'Records are incomplete for this day.',
    incompleteText: 'Compliance cannot be assessed until the day is fully recorded.',
    noFindings: 'All MLC requirements are within limits.',
    noViolations: 'No violations detected.',
    exception: 'Emergency — master’s signed exception required',
    rule: {
      MIN_REST_24H: 'Rest in 24 hours {{value}} h (min {{limit}} h)',
      MIN_REST_7D: 'Rest in 7 days {{value}} h (min {{limit}} h)',
      MAX_WORK_24H: 'Work in 24 hours {{value}} h (max {{limit}} h)',
      MAX_WORK_7D: 'Work in 7 days {{value}} h (max {{limit}} h)',
      REST_PERIODS_MAX_TWO: 'Rest split into {{value}} periods (max {{limit}})',
      REST_PERIOD_MIN_6H: 'Longest rest {{value}} h (min {{limit}} h)',
      REST_INTERVAL_MAX_14H: '{{value}} h between rest periods (max {{limit}} h)',
    },
    error: 'Hours of work and rest could not be loaded.',
  },
  voyage: {
    // Gemi saati kaydıyla tutarsız fark (ADR 0065 §8)
    clockHint:
      "Ship's Clock Log: {{log}} at this time; this report uses {{report}}. Check the offset — the report is not changed automatically.",
    noon: {
      title: 'Noon Report',
      description:
        'Complete the noon report with current vessel data. The information will be used for voyage, performance and compliance reports.',
      descriptionOffice:
        'Noon reports are entered and submitted on board. The office sees the submitted report.',
      tabs: {
        voyage: 'Voyage',
        navigation: 'Navigation',
        machinery: 'Machinery',
        fuel: 'Fuel & ROB',
        weather: 'Weather & Sea',
        attachments: 'Attachments',
      },
      header: {
        voyageNo: 'Voyage No',
        leg: 'Leg',
        from: 'From',
        to: 'To',
        reportTime: 'Report Date & Time',
      },
      status: {
        draft: 'Draft',
        submitted: 'Submitted',
        reopened: 'Reopened',
        void: 'Void',
        new: 'New',
      },
      voyageTab: {
        title: 'Voyage',
        charterParty: 'Charter Party',
        charterer: 'Charterer',
        plannedDistance: 'Planned Distance',
        plannedEtd: 'Estimated Time of Departure (ETD)',
        plannedEta: 'Estimated Time of Arrival (ETA)',
        cpSpeed: 'CP Speed (Laden / Ballast)',
        cpConsumption: 'CP Consumption (Laden / Ballast)',
        cpWeather: 'CP Weather Limit',
        voyageStatus: 'Voyage Status',
        started: 'Voyage Start',
        fuel: 'Fuel Type (ME / AE)',
        beaufortMax: 'Beaufort {{value}}, Hs {{height}} m',
      },
      navigation: {
        title: 'Navigation',
        position: 'Position & Course',
        latitude: 'Latitude',
        longitude: 'Longitude',
        course: 'Course (°)',
        heading: 'True Heading (°)',
        sog: 'Speed Over Ground (kn)',
        stw: 'Speed Through Water (kn)',
        distances: 'Distances & Speed',
        distanceSinceLast: 'Distance Since Last Report (nm)',
        distanceThroughWater: 'Distance Through Water (nm)',
        distanceOverGround: 'Distance Over Ground (nm)',
        distanceToGo: 'Distance To Go (nm)',
        averageSpeed: 'Average Speed (kn)',
        nextWaypoint: 'Next Waypoint',
        steaming: 'Steaming Time Since Last Report',
        previousTime: 'Previous Report Time (COSP / Noon)',
        currentTime: 'Current Report Time',
        currentTimeZone: 'Current Report Time (LT, {{zone}})',
        steamingTime: 'Steaming Time (h)',
        steamingNote: 'Calculated automatically from the previous report time.',
        noPrevious: 'No previous report',
        timeZone: 'Time Zone',
        utcOffset: 'UTC Offset',
        utcNote: 'Select from the list or type ±HH:MM.',
        remarks: 'Navigation Remarks',
        remarksPlaceholder: 'Enter navigation remarks…',
      },
      machinery: {
        title: 'Machinery',
        performance: 'Main Engine Performance',
        mainEngine: 'Main Engine',
        engineSpeed: 'Engine Speed (RPM)',
        engineLoad: 'Engine Load',
        shaftSpeed: 'Shaft Speed (RPM)',
        runningHours: 'Running Hours',
        power: 'Power (kW)',
        status: 'Status',
        propeller: 'Propeller & Pitch',
        propellerType: 'Propeller Type',
        pitch: 'Propeller Pitch',
        diameter: 'Propeller Diameter',
        speed: 'Speed Calculation',
        theoreticalSpeed: 'Theoretical Speed (kn)',
        theoreticalSpeedShort: 'Theoretical Speed',
        theoreticalFormula: 'Theoretical speed = propeller pitch × shaft RPM × 60 / 1852',
        stw: 'Speed Through Water (STW) (kn)',
        sog: 'Speed Over Ground (SOG) (kn)',
        current: 'Current (kn)',
        slip: 'Propeller Slip (%)',
        slipShort: 'Slip (%)',
        slipSog: 'Slip by SOG (%)',
        currentEffect: 'Current Effect (STW − SOG)',
        slipSogNote:
          'Slip (%) uses speed through water; Slip by SOG uses speed over ground. Current effect = (STW − SOG) / STW: negative when the current helps.',
        slipRangeNote:
          'Usual apparent slip of a laden vessel in normal weather; outside the range check the RPM, pitch and STW entries.',
        slipDetails: 'Slip Calculation Details',
        slipFormula: '(Theoretical Speed − STW) / Theoretical Speed × 100',
        difference: 'Difference',
        slipNormal: 'Slip value is within normal range.',
        slipOut: 'Slip value is outside the typical range.',
        slipRange: 'Typical range: {{from}} – {{to}}%',
        auxiliary: 'Auxiliary Machinery',
        auxiliaryTable: 'Auxiliary machinery table',
        runningHoursShort: 'Running Hours',
        hoursSinceLast: 'Hours Since Last Report',
        hoursSinceLastShort: 'Since Last (h)',
        runningHoursOf: '{{name}} RH',
        loadShort: 'Load',
        powerShort: 'Power',
        fuelConsumption: 'Fuel Consumption',
        fuelOf: 'Fuel Consumption ({{fuel}})',
        remarksPlaceholder: 'Enter machinery remarks…',
        equipment: 'Equipment',
        rpm: 'RPM',
        load: 'Load (%)',
        consumption: 'Fuel Consumption (MT)',
        remarks: 'Remarks',
        machineryRemarks: 'Machinery Remarks',
        addAuxiliary: 'Add equipment',
        removeRow: 'Remove row',
        generators: 'Generators',
        boilerOthers: 'Boiler & Others',
        noAuxiliary: 'No auxiliary machinery entered.',
        consumption24h: 'Fuel Consumption (24h)',
      },
      fuel: {
        title: 'Fuel & ROB',
        fuelType: 'Fuel Type',
        opening: 'Opening ROB',
        consumption: 'Consumption',
        bunkering: 'Bunkering',
        closing: 'Closing ROB',
        lubes: 'Lubricating Oil / Others',
        freshWater: 'Fresh Water',
        rob: 'ROB',
        produced: 'Produced',
        bunkered: 'Bunkered',
        addFuel: 'Add fuel',
        addLube: 'Add oil',
        addFreshWater: 'Add fresh water',
        name: 'Name',
        unit: 'MT',
        noFuel: 'Enter at least one fuel.',
      },
      fuelSummary: {
        title: 'Fuel Consumption & ROB',
        table: 'Fuel consumption and ROB by fuel',
        consumption: 'Consumption (MT)',
        rob: 'ROB (MT)',
        total: 'Total',
        robFuel: 'ROB – Fuel (MT)',
        robLube: 'ROB – Lube Oil (MT)',
        robTotal: 'Total ROB (MT)',
      },
      weather: {
        title: 'Weather & Sea',
        wind: 'Wind',
        direction: 'Direction (°)',
        speed: 'Speed (kn)',
        beaufort: 'Beaufort',
        sea: 'Sea',
        seaState: 'Sea State (Douglas)',
        swellDirection: 'Swell Direction (°)',
        swellHeight: 'Swell Height (m)',
        swellPeriod: 'Swell Period (s)',
        weather: 'Weather',
        condition: 'Condition',
        visibility: 'Visibility (nm)',
        airTemp: 'Air Temperature (°C)',
        seaTemp: 'Sea Temperature (°C)',
        pressure: 'Barometric Pressure (hPa)',
        current: 'Current',
        relation: 'Relative',
        remarks: 'Weather Remarks',
        short: {
          wind: 'Wind',
          direction: 'Direction',
          speed: 'Speed',
          beaufort: 'Beaufort',
          sea: 'Sea',
          seaState: 'Sea State',
          swellDirection: 'Swell Direction',
          swellHeight: 'Swell Height',
          swellPeriod: 'Swell Period',
          weather: 'Weather',
          visibility: 'Visibility',
          airTemp: 'Air Temperature',
          seaTemp: 'Sea Temperature',
          pressure: 'Barometric Pressure',
          current: 'Current',
        },
      },
      relation: { head: 'Head', following: 'Following', beam: 'Beam' },
      propellerType: { fixed: 'Fixed Pitch', controllable: 'Controllable Pitch' },
      machineryStatus: {
        running: 'Running',
        standby: 'Standby',
        stopped: 'Stopped',
        not_in_use: 'Not in use',
      },
      attachments: {
        title: 'Attachments',
        pdf: 'Noon Report PDF',
        notGenerated: 'Not generated',
        supporting: 'Supporting Documents',
        files: '{{count}} files',
        upload: 'Upload',
        uploadLater: 'Attaching files to voyage reports comes with the attachments step (M11c).',
        pdfReady: 'A4, LT and UTC, approval details',
        print: 'Print / PDF',
        uploadTypes: 'Upload photo or document (JPG, PNG, PDF; max 25 MB)',
        saveFirst: 'Save the draft first, then attach files.',
        locked:
          'Submitted reports are locked: files can be added after the Master reopens the report.',
        uploaded: '{{name}} attached.',
        drop: 'Drag & drop files here or click to upload',
        types: '(PDF, JPG, PNG, DOCX)',
        attached: 'Attached Files ({{count}})',
        none: 'No files attached yet.',
        later:
          'Attaching files to voyage reports comes with M11c. The PDF of the report is produced by the reports module.',
      },
      // Referans paneli (ADR 0059 §5; g3 §2, §3, §7)
      reference: {
        title: 'Passage Reference',
        cosp: {
          title: 'COSP Reference',
          time: 'COSP Date / Time',
          position: 'COSP Position',
          elapsed: 'Time Since COSP',
          distance: 'Distance Since COSP',
          avgSpeed: 'Average Speed',
          none: 'No open sea passage (COSP) before this report.',
        },
        previous: {
          title: 'Previous Report',
          type: 'Previous Report Type',
          time: 'Previous Report Date / Time',
          elapsed: 'Time Elapsed Since Last Report',
          none: 'No earlier report in this voyage.',
        },
        eta: {
          title: 'ETA / Port Information',
          nextPort: 'Next Port',
          chartArea: 'Chart Datum / Area',
          eta: 'ETA at Next Port',
          total: 'Total Voyage Distance',
          run: 'Distance Run (voyage)',
          remaining: 'Remaining Distance',
          suggested: 'ETA at {{speed}} kn',
          apply: 'Use suggested ETA',
        },
      },
      cp: {
        title: 'Charter Party Performance',
        status: 'Charter Party Status',
        statuses: { on_hire: 'On Hire', off_hire: 'Off Hire' },
        plannedSpeed: 'Planned Speed',
        actualSpeed: 'Actual Speed',
        plannedConsumption: 'Planned Consumption',
        actualConsumption: 'Actual Consumption',
        within: 'Within charter party limits.',
        outside: 'Outside charter party limits.',
        partial: 'Speed within CP · consumption n/a.',
        unknown: 'Load condition unknown: enter it in the COSP report.',
        perDay: '{{value}} MT/day',
      },
      mlc: {
        title: 'MLC Compliance',
        rest24h: '24h Rest',
        rest7d: '7d Rest',
        compliant: 'Compliant',
        warning: 'Warning',
        violation: 'Violation',
        incomplete: 'Incomplete',
        allWithin: 'All limits are within MLC requirements.',
        notAll: 'Some limits are not met: see Hours of Work & Rest.',
        noRecords: 'No hours of rest recorded for this day.',
        viewDetails: 'View Details',
        worstOf: 'Lowest rest on board',
      },
      summary: {
        title: 'Quick Summary',
        work24h: 'Total Work (24h)',
        rest24h: 'Total Rest (24h)',
        work7d: 'Total Work (7 days)',
        rest7d: 'Total Rest (7 days)',
      },
      alerts: {
        title: 'Alerts & Notifications',
        none: 'No active alerts.',
        slip: 'Propeller slip {{value}}% is outside the typical range (5–15%).',
        cpSpeed: 'Average speed {{value}} kn is below the CP speed {{limit}} kn.',
        cpWeather: 'Beaufort {{value}} exceeds the CP weather limit ({{limit}}).',
        mlc: 'Hours of rest: not all crew are within MLC limits.',
      },
      actions: {
        saveDraft: 'Save Draft',
        submit: 'Submit Noon Report',
        reopen: 'Edit (reopen)',
        newReport: 'New report',
        print: 'Print',
        preview: 'Preview',
        printLater: 'Print and preview come with the reports module.',
        printPdf: 'Print / PDF',
      },
      machinerySummary: {
        title: 'Quick Summary',
        engineLoad: 'Total Engine Load',
        slip: 'Slip',
        consumption: 'Fuel Consumption',
        rob: 'ROB (Total)',
      },
      navigationStatus: {
        title: 'Navigation Status',
        position: 'Position',
        courseSpeed: 'Course / Speed',
        weather: 'Weather',
        wind: 'Wind',
        seaState: 'Sea State',
        current: 'Current',
      },
      noRemarks: 'No remarks',
      noVoyageTitle: 'No active voyage',
      noVoyageShip:
        'No voyage yet. Enter the departure report under Voyage › Reports › All Reports ▸ Add New Report; the voyage starts from the departure.',
      noVoyageOffice: 'Voyages are planned on board; they appear here after synchronisation.',
      noReportHint:
        'Noon reports are entered on board; the submitted report appears here after synchronisation.',
      lastSubmitted: 'Last submitted: {{at}} (UTC)',
      by: 'by {{name}}',
      saved: 'Draft saved.',
      submitted: 'Noon report submitted.',
      reopened: 'Report reopened for correction.',
      noVoyage:
        'There is no active voyage for this vessel. Voyages are planned on board under Voyage › Create New Voyage.',
      noReport: 'No noon report has been submitted for this voyage yet.',
      readOnly: 'Submitted reports are locked. The master can reopen them with a reason.',
      error: 'The noon report could not be loaded.',
      retry: 'Try again',
      reopenDialog: {
        title: 'Edit submitted report',
        body: 'The report is reopened for correction. After your changes, submit it again: it becomes a new revision and the submitted version stays in the history.',
        reason: 'Reason',
        password: 'Password',
        confirm: 'Reopen',
        cancel: 'Cancel',
      },
      required: 'Required',
    },
    // Ortak rapor bölümleri (ADR 0057 §3, §5)
    sections: {
      // Kalkış ve varış (ADR 0058)
      pilot: {
        title: 'Pilot, Cast Off & Tugs',
        castOff: 'Cast Off (last line)',
        castOffNote:
          'The event time of the departure is Cast Off: the moment the last line is let go. Pilot off is a separate time.',
        notUsed: 'No pilot used (N/A)',
        onBoard: 'Pilot On Board',
        off: 'Pilot Off',
        tugsUsed: 'Number of Tugs Used',
        tugsFromRows: 'The number follows the tug rows below. Enter 0 when no tug was used.',
      },
      nextPort: {
        title: 'Next Port',
        port: 'Next Port',
        distance: 'Distance to Next Port',
        eta: 'ETA Next Port',
        unknownReason: 'Next port unknown – reason',
        note: 'Select the next port, or give the reason when it is not known yet (e.g. awaiting orders).',
      },
      load: {
        title: 'Draft & Loading Condition',
        condition: 'Laden / Ballast',
        airDraft: 'Air Draft',
        draftFwd: 'Draft FWD',
        draftAft: 'Draft AFT',
        displacement: 'Displacement',
      },
      cargo: {
        title: 'Cargo & Operations',
        operationDone: 'Cargo Operation at this Port',
        operationPlanned: 'Planned Cargo Operation',
        operations: {
          loading: 'Loaded',
          discharging: 'Discharged',
          both: 'Loaded and discharged',
          none: 'No cargo operation',
        },
        row: 'Cargo {{no}}',
        type: 'Cargo Type',
        unit: 'Unit',
        units: { MT: 'MT', M3: 'm³', TEU: 'TEU', UNITS: 'Units' },
        remove: 'Remove cargo {{no}}',
        loaded: 'Loaded Quantity',
        discharged: 'Discharged Quantity',
        toLoad: 'To Load',
        toDischarge: 'To Discharge',
        add: 'Add Cargo',
        onBoard: 'Total Cargo On Board',
        onBoardUnit: 'On Board Unit',
        remarks: 'Cargo Remarks',
        note: 'Loaded and discharged quantities are this port only; the total on board is entered separately.',
      },
      classification: {
        title: 'Departure Classification',
        employment: 'Employment Status',
        employments: {
          chartered: 'Chartered / Commercial',
          unemployed: 'Unemployed / No charter',
          owners_operation: "Owner's operation",
          maintenance: 'Maintenance / Repair / Yard',
        },
        purpose: 'Purpose of Departure',
        purposes: {
          cargo_voyage: 'Cargo / Commercial voyage',
          repositioning: 'Repositioning',
          sea_trial: 'Sea trial / Test',
          bunker: 'Bunker / Supply',
          other: 'Other',
        },
        purposeOther: 'Other purpose (specify)',
        charterReference: 'Charter / Voyage Reference',
        euRoute: 'EU Route Screening',
        euRoutes: {
          eu_eu: 'EU → EU',
          eu_non_eu: 'EU → non-EU',
          non_eu_eu: 'non-EU → EU',
          non_eu_non_eu: 'non-EU → non-EU',
          unknown: 'Unknown',
        },
        mrv: 'MRV Review',
        mrvStatuses: {
          not_assessed: 'Not assessed',
          review_required: 'Review required',
          assessed: 'Assessed',
        },
        euRouteDerived:
          'Derived from the departure and next port. Screening only: the MRV scope is assessed separately.',
        euRouteManual: 'Corrected by hand. Screening only: the MRV scope is assessed separately.',
      },
      decision: {
        title: 'Voyage Decision',
        question: 'How is this departure linked to a voyage?',
        actions: { link: 'Link to voyage', create: 'Start a new voyage', none: 'No voyage yet' },
        hints: {
          link: 'The departure belongs to a running or planned voyage',
          create:
            'After submitting, the voyage form opens filled from this departure; saving it starts the voyage',
          none: 'The departure stays without a voyage (reason required)',
        },
        voyage: 'Voyage',
        noVoyage: 'Select a voyage',
        reason: 'Reason no voyage is created',
        note: 'A departure is not always a new voyage. A voyage can be started or linked later; the submitted departure does not change.',
        startTitle: 'Start the Voyage',
        startNote:
          'This departure is not linked to a voyage. Start a new voyage filled from it, or link it and the reports after it to a voyage.',
        start: 'Start Voyage',
        linkPlanned: 'Planned voyage',
        link: 'Link',
      },
      finalCheck: {
        title: 'Final Check',
        criticalOpen:
          '{{count}} critical open defect(s) on board. Check restrictions before departure. This warning does not block the report; if you select a defect below, write its restrictions.',
        checklist: 'Departure Checklist',
        statuses: { complete: 'Complete', incomplete: 'Incomplete', not_applicable: 'N/A' },
        record: 'Checklist Record (ISM Forms)',
        noRecords: 'No form records in the last 30 days',
        checklistRemarks: 'Checklist Remarks',
        defects: 'Open Defects / Restrictions',
        noDefects: 'No open defects',
        restrictions: 'Restrictions / Operational Limitations',
      },
      portCall: {
        title: 'Port Call',
        call: 'Port Call',
        none: 'No port calls',
        apply: 'Apply',
        suggest: {
          atd: 'Port call {{port}}: ATD {{current}}. Set it to the cast off time {{at}} (UTC)?',
          ata: 'Port call {{port}}: ATA {{current}}. Set it to the berthing time {{at}} (UTC)?',
        },
      },
      nor: {
        title: 'NOR (Notice of Readiness)',
        tenderedAt: 'NOR Tendered',
        tenderedTo: 'Tendered To',
        acceptedAt: 'NOR Accepted',
        acceptedBy: 'Accepted By',
        laytime: 'Laytime Commencement',
        remarks: 'NOR Remarks',
      },
      mooring: {
        title: 'Mooring',
        lines: 'Number of Mooring Lines',
        shoreLines: 'Shore Lines',
        remarks: 'Mooring Remarks',
      },
      passage: {
        title: 'Sea Passage (COSP → EOSP)',
        cosp: 'COSP',
        elapsed: 'Time Elapsed',
        distance: 'Total Distance',
        avgSpeed: 'Average Speed',
        fuel: 'Bunker consumption during sea passage (MT)',
        atCosp: 'At COSP',
        atEosp: 'At EOSP',
        consumed: 'Consumed',
        cpSpeed: 'CP Speed ({{load}})',
        cpAllowed: 'Allowed Consumption',
        cpActual: 'Actual Consumption',
        cpDiff: 'Difference',
        note: 'Gross figures from COSP to this EOSP; stoppages are not deducted. The charter party window is on the Charter Party screen.',
        noCosp: 'No COSP before this EOSP.',
      },
      eospRef: {
        title: 'End of Sea Passage',
        time: 'EOSP',
        position: 'EOSP Position',
        distanceToPort: 'Distance to Port',
        rob: 'ROB at EOSP (MT)',
      },
      tugs: {
        title: 'Tugs',
        none: 'No tugs entered. Add one row per tug used.',
        row: 'Tug {{no}}',
        name: 'Tug Name',
        bollardPull: 'Bollard Pull (t)',
        alongside: 'Alongside / Made Fast',
        castOff: 'Cast Off / Let Go',
        add: 'Add Tug',
        remove: 'Remove tug {{no}}',
        legacy: 'Tug details (earlier entry): {{text}}',
      },
      rob: {
        title: 'ROB – Fuel, Lube Oil & Fresh Water (MT)',
        type: 'Type',
        fuel: 'Fuel',
        lube: 'Lube Oil',
        water: 'Water',
        freshWater: 'Fresh Water',
        previous: 'Previous',
        consumed: 'Consumed',
        sinceLast: 'Since Last',
        today: 'Today',
        rob: 'ROB',
        addLube: 'Add Lube Oil',
        addWater: 'Add Fresh Water',
        remove: 'Remove {{name}}',
        note: 'All quantities in metric tonnes. Previous comes from the last report; when Consumed is empty it is filled as Previous − ROB.',
      },
      lubes: {
        ME_CYL: 'ME Cylinder Oil',
        ME_SYS: 'ME System Oil',
        AE_LO: 'AE Lube Oil',
        STERN_TUBE: 'Stern Tube Oil',
        HYDRAULIC: 'Hydraulic Oil',
        OTHER: 'Other Oil',
      },
      weather: {
        title: 'Weather',
        windDirection: 'Wind Direction',
        beaufort: 'Wind Force (Beaufort)',
        seaState: 'Sea State (Douglas)',
        visibility: 'Visibility',
        airTemp: 'Air Temperature (°C)',
        seaTemp: 'Sea Temperature (°C)',
      },
      beaufortScale: {
        '0': 'Calm',
        '1': 'Light air',
        '2': 'Light breeze',
        '3': 'Gentle breeze',
        '4': 'Moderate breeze',
        '5': 'Fresh breeze',
        '6': 'Strong breeze',
        '7': 'Near gale',
        '8': 'Gale',
        '9': 'Strong gale',
        '10': 'Storm',
        '11': 'Violent storm',
        '12': 'Hurricane',
      },
      douglasScale: {
        '0': 'Calm (glassy)',
        '1': 'Calm (rippled)',
        '2': 'Smooth',
        '3': 'Slight',
        '4': 'Moderate',
        '5': 'Rough',
        '6': 'Very rough',
        '7': 'High',
        '8': 'Very high',
        '9': 'Phenomenal',
      },
      visibilityGrades: {
        very_poor: 'Very poor (< 1000 m)',
        poor: 'Poor (1000 m – 2 nm)',
        moderate: 'Moderate (2–5 nm)',
        good: 'Good (> 5 nm)',
      },
      persons: {
        title: 'Persons on Board',
        crew: 'Crew',
        passengers: 'Passengers / Others',
      },
      condition: {
        title: 'Ship Condition',
        hull: 'Hull',
        machinery: 'Machinery',
        navigation: 'Navigation Equipment',
        safety: 'Safety Equipment',
        classCertificates: 'Class Certificates',
        statutoryCertificates: 'Statutory Certificates',
        remarks: 'Condition Remarks / Defects',
      },
      conditionGrades: {
        satisfactory: 'Satisfactory',
        unsatisfactory: 'Unsatisfactory',
        not_checked: 'Not checked',
      },
      certificateGrades: {
        valid: 'Valid',
        expiring: 'Expiring',
        expired: 'Expired',
        not_checked: 'Not checked',
      },
      next: {
        title: 'Next Operation',
        question: 'What will the vessel do next?',
        nextReport: 'Open now:',
        note: "Required to submit. The choice is saved with the report and decides the next report; when it is due, open it from the Next Report card. 'Open now' only opens the form and saves nothing. To change the choice, the Master reopens the report with a reason.",
        operations: {
          sea_passage: 'Sea Passage',
          berth: 'Berth',
          anchorage: 'Anchorage',
          drifting: 'Drifting',
          strait_canal: 'Canal / Strait Transit',
          waiting_orders: 'Waiting for Orders',
          departure: 'Departure',
          port_stay: 'Stay in Port',
        },
        leadsTo: {
          sea_passage: 'COSP, Noon, EOSP',
          berth: 'Berthing (Arrival) Report',
          anchorage: 'At Anchor, Daily, Anchor Up',
          drifting: 'Drifting, Drift Daily, Drift End',
          strait_canal: 'Strait / Canal Entry and Exit',
          waiting_orders: 'Waiting Start and End',
          departure: 'Next: Departure Report (also when shifting berth or moving to anchorage)',
          port_stay: 'Next: Port Daily Report (one per day; depart any time)',
        },
        // Aşamanın devamı (Noon, demirde, driftte...): seçenek "kal / sürdür" diye okunur
        continue: {
          sea_passage: {
            label: 'Continue Sea Passage',
            leadsTo:
              'Next: Noon Report or EOSP (or a strait, canal, anchoring, drift or waiting start)',
          },
          anchorage: {
            label: 'Stay at Anchor',
            leadsTo: 'Next: Anchorage Daily Report or Anchor Up',
          },
          drifting: {
            label: 'Continue Drifting',
            leadsTo: 'Next: Drift Daily Report or Drift End',
          },
          waiting_orders: { label: 'Continue Waiting for Orders', leadsTo: 'Next: Waiting End' },
          strait_canal: { label: 'Continue Transit', leadsTo: 'Next: Strait / Canal Exit' },
        },
      },
    },
    // Ortak rapor çıktısı (ADR 0057 §7)
    pdf: {
      reportNo: 'Report No: {{no}}',
      noVoyage: 'No voyage yet',
      amended: 'AMENDED',
      castOff: 'Cast Off (LT / UTC)',
      vessel: 'Vessel',
      voyage: 'Voyage No',
      from: 'From',
      to: 'To',
      reportTimeLt: 'Report Time (LT)',
      reportTimeUtc: 'Report Time (UTC)',
      position: 'Position',
      status: 'Status',
      approval: 'Approval',
      submittedBy: 'Submitted by',
      role: 'Role',
      submittedAt: 'Submitted at',
      revision: 'Revision',
      notSubmitted: 'Not submitted (draft)',
      reopenedAt: 'Reopened at',
      reopenReason: 'Reason',
      approvalNote:
        'Electronically submitted in Felixmate; the approval record replaces a handwritten signature.',
      draftMark: 'DRAFT – NOT SUBMITTED',
      reopenedMark: 'REOPENED – UNDER CORRECTION',
      // Gerekçeli iptal (ADR 0077 §3)
      voidMark: 'VOID – NOT VALID',
      voidedAt: 'Voided at',
      voidReason: 'Void reason',
      printed: 'Printed {{at}}',
      page: 'Page {{page}} / {{pages}}',
      error: 'The PDF could not be produced.',
    },
    // Seferin günlük raporları (ADR 0059): limanda, demirde, sürüklenmede
    daily: {
      reference: {
        port_daily: 'From Berthing Report (auto)',
        anchorage_daily: 'From Anchorage Report (auto)',
        drift_daily: 'From Drift Start Report (auto)',
        allFast: 'All Fast (Date / Time)',
        firstLine: 'First Line at Shore',
        pilotOff: 'Pilot Off (Date / Time)',
        tugs: 'Tugs (last)',
        started: { anchorage_start: 'Anchor Down', drift_start: 'Drift Started' },
        position: 'Position',
        reason: 'Reason',
        none: {
          port_daily: 'No berthing report before this report.',
          anchorage_daily: 'No anchorage report before this report.',
          drift_daily: 'No drift start report before this report.',
        },
      },
      sinceLast: {
        type: 'Last Report Type',
        time: 'Last Report Date / Time',
        elapsed: 'Time Since Last Report',
      },
      location: {
        title: 'Location Status',
        port: {
          port_daily: 'Port',
          anchorage_daily: 'Port / Anchorage',
          drift_daily: 'Nearest Port',
        },
        area: {
          port_daily: 'Terminal / Berth',
          anchorage_daily: 'Anchorage Area',
          drift_daily: 'Drifting Area',
        },
        activity: 'Activity Status',
        berthSide: 'Berth Side',
      },
      activities: {
        alongside: 'Alongside (All Fast)',
        cargo_operation: 'Cargo Operation',
        bunkering: 'Bunkering',
        repairs: 'Repairs / Maintenance',
        waiting: 'Waiting',
        at_anchor: 'At Anchor',
        drifting: 'Drifting',
        other: 'Other',
      },
      berthSides: { port: 'Port Side', starboard: 'Starboard Side' },
      etd: {
        title: 'ETD',
        etd: 'Estimated Time of Departure',
        remarks: 'ETD Remarks',
        note: 'Local time of this report; the ETD may be in the future.',
      },
      cargo: {
        title: 'Cargo / Operation',
        loadCondition: 'Ship Condition',
        operation: 'Operation',
        operations: {
          loading: 'Loading',
          discharging: 'Discharging',
          both: 'Loading and discharging',
          none: 'No cargo operation',
        },
        cargoType: 'Cargo',
        unit: 'Unit',
        planned: 'Planned Quantity',
        sinceLast: 'Handled Since Last Report',
        total: 'Total Handled',
        remaining: 'Remaining Quantity',
        remarks: 'Cargo Remarks',
        note: 'Total = previous daily total + handled since last report (suggested, editable). Remaining = planned − total.',
      },
      hours: {
        title: 'Machinery Running Hours',
        equipment: 'Equipment',
        sinceLast: 'Since Last (h)',
        today: 'Today (h)',
        total: 'Total (h)',
        sinceLastH: 'Since last report',
        todayH: 'Today',
        totalH: 'Total running hours',
        remarks: 'Remarks',
        remove: 'Remove row',
        none: 'No equipment rows.',
        add: 'Add Equipment',
        note: 'Total = previous total + since last report (suggested). The hours stay in this report; PMS counters are updated from the Noon Report or in PMS.',
      },
    },
    // All Reports (ADR 0082; ortağın sefer-6)
    allReports: allReportsEn,
    record: voyageRecordEn,
    links: voyageLinksEn,
    context: voyageContextEn,
    charterParties: charterPartiesEn,
    cpAnalysis: cpAnalysisEn,
    // Seferin CP'si ve performans referansı (ADR 0084 Ek 2)
    cpReference: voyageReferenceEn,
    // Fuel & Consumption Analysis ve panonun sefer kartları (V6; ADR 0090)
    fuelAnalysis: fuelAnalysisEn,
    cards: voyageCardsEn,
    kinds: {
      departure: 'Departure Report',
      cosp: 'COSP Report',
      noon: 'Noon Report',
      eosp: 'EOSP Report',
      arrival: 'Arrival Report',
      port_daily: 'Port Daily',
      anchorage_start: 'Anchor Dropped',
      anchorage_daily: 'Anchorage Daily',
      anchorage_end: 'Anchor Aweigh',
      waiting_start: 'Waiting Start',
      waiting_end: 'Waiting End',
      drift_start: 'Drift Start',
      drift_daily: 'Drift Daily',
      drift_end: 'Drift End',
      strait_entry: 'Strait Entry',
      strait_exit: 'Strait Exit',
      canal_entry: 'Canal Entry',
      canal_exit: 'Canal Exit',
      cargo_start: 'Cargo Operation Start',
      cargo_complete: 'Cargo Operation Complete',
      on_hire: 'On-Hire',
      off_hire: 'Off-Hire',
    },
    voyageStatus: {
      planned: 'Planned',
      active: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      void: 'Void',
    },
    reportStatus: { draft: 'Draft', submitted: 'Completed', reopened: 'Reopened', void: 'Void' },
    overview: {
      title: 'Voyage Overview',
      description: 'Voyage summary, reports and charter party performance.',
      selectVoyage: 'Voyage',
      from: 'From',
      to: 'To',
      totalDistance: 'Total Distance',
      plannedSpeed: 'Planned Speed',
      plannedTime: 'Planned Time',
      eta: 'Estimated Time of Arrival (ETA)',
      editVoyage: 'Edit Voyage',
      tree: 'Voyage Tree',
      created: 'Voyage Created',
      voyageNo: 'Voyage No: {{no}}',
      stages: { departure: 'Departure / Sailing', enRoute: 'En Route', arrival: 'Arrival' },
      completedNode: 'Voyage Completed',
      noReports: 'No reports yet.',
      summary: 'Voyage Summary',
      actualDistance: 'Actual Distance',
      avgSpeed: 'Avg. Speed',
      totalTime: 'Total Time',
      delay: 'Delay',
      track: 'Track',
      trackNote: 'Positions from the voyage reports.',
      noTrack: 'No positions reported yet.',
      speedPerformance: 'Speed Performance',
      planned: 'Planned',
      difference: 'Difference',
      onCharter: 'On charter party',
      offCharter: 'Below charter party speed',
      cpCompliance: 'Charter Party Compliance',
      withinCp: 'Within CP',
      allowedSpeed: 'Allowed Speed',
      log: 'Voyage Log',
      date: 'Date',
      reportType: 'Report Type',
      timeUtc: 'Time (UTC)',
      speed: 'Speed (kn)',
      distance: 'Distance (NM)',
      status: 'Status',
      keyFigures: 'Key Figures',
      departurePort: 'Departure Port',
      arrivalPort: 'Arrival Port',
      distanceShort: 'Distance',
      actualArrival: 'Actual Arrival',
      cpStatus: 'Speed & CP Status',
      parameter: 'Parameter',
      actual: 'Actual',
      ok: 'OK',
      check: 'Check',
      withinCharter: 'Within Charter Party',
      outsideCharter: 'Outside Charter Party',
      verdict: {
        within: 'Within Charter Party',
        outside: 'Outside Charter Party',
        partial: 'Speed within CP',
        unknown: 'Not evaluated',
      },
      alerts: 'Alerts & Notifications',
      draftPending: '{{kind}} not submitted',
      noAlerts: 'No active alerts.',
      quickActions: 'Quick Actions',
      createNoon: 'Create Noon Report',
      createEvent: 'Leg / Event Report',
      notes: 'Voyage Notes',
      noNotes: 'No notes added yet.',
      documents: 'Documents',
      documentsLater: 'Voyage documents come with the attachments step.',
      noVoyages: 'No voyages for this vessel yet.',
      shipPlanned: 'Voyages are planned on board; they appear here after synchronisation.',
      officePlan: 'Plan the first voyage of this vessel under Create New Voyage.',
      etaUtc: 'Estimated Time of Arrival (ETA)',
      etd: 'Estimated Time of Departure (ETD)',
      delayUnknown: 'The delay is calculated from the arrival report.',
      trackLabel: 'Voyage track from {{from}} towards {{to}}: {{count}} reported positions',
      cpStatusTable: 'Speed and charter party status',
      logTable: 'Voyage log table',
      addReport: 'Add Report',
      showLatest: 'Show latest',
      viewAllCount: 'View all ({{count}})',
      noDocuments: 'No documents attached yet.',
      documentsHint: 'Voyage documents are attached with the attachments step.',
      noReportsStage: 'No reports yet.',
      createDeparture: 'Create Departure Report',
      firstReportHint:
        'Start the voyage with its Departure report. A vessel joining mid-voyage can start with a Noon or EOSP report under Leg / Event.',
      reportsFromShip: 'Reports are entered on board.',
      reportsFromShipHint:
        'Voyage reports are entered on board and arrive here with the next synchronisation.',
      noonReports: 'Noon Reports',
      viewAll: 'View All',
      speedWithin: 'Speed within Charter Party',
      speedBelow: 'Speed below Charter Party',
      throughout: 'Throughout voyage',
      createArrival: 'Create Arrival Report',
      createCosp: 'Create COSP Report',
      createEosp: 'Create EOSP Report',
      error: 'Voyages could not be loaded.',
      retry: 'Try again',
    },
    planner: {
      suggestNo: 'Use the suggested number',
      voyageNoHint: 'Type your own voyage number or leave empty to use the suggestion.',
      title: 'Create New Voyage',
      editTitle: 'Edit Voyage',
      cardTitle: 'New Voyage',
      fromDeparture:
        'This voyage starts with departure {{no}} from {{port}}, cast off {{at}}. Known values are filled from the report.',
      cardDescription: 'Create a new voyage with planned charter party details.',
      status: 'Status',
      information: 'Voyage Information',
      voyageNo: 'Voyage No',
      vessel: 'Vessel',
      fromPort: 'From Port',
      toPort: 'To Port',
      plannedDistance: 'Planned Distance',
      plannedEtd: 'Estimated Time of Departure (ETD)',
      plannedEta: 'Estimated Time of Arrival (ETA)',
      utcOffset: 'UTC Offset',
      utcOffsetOf: 'UTC Offset ({{name}})',
      localTimeHint: 'Local time of the port',
      remarks: 'Remarks',
      remarksPlaceholder: 'Enter remarks…',
      charterParty: 'Planned Charter Party',
      cpSpeed: 'CP Speed (knots)',
      cpRegisterNote:
        'Charter party terms are kept once in the Charter Party Register (office). A voyage does not start the charter: the charter period runs from the On Hire to the Off Hire report.',
      cpRegisterOpen: 'Open Charter Party Register',
      cpLegacy: 'Recorded on this voyage by an earlier version (read-only):',
      fuelConsumption: 'Fuel Consumption',
      laden: 'Laden',
      ballast: 'Ballast',
      fuelType: 'Fuel Type',
      mainEngine: 'Main Engine',
      auxEngine: 'Auxiliary Engine',
      weatherLimit: 'CP Weather Limit',
      beaufortMax: 'Beaufort (max)',
      waveHeight: 'Significant Wave Height',
      charterer: 'Charterer',
      charterPartyNo: 'Charter Party No',
      notes: 'Additional Notes',
      notesPlaceholder: 'Enter additional notes…',
      summary: 'Voyage Summary',
      cpSpeedLaden: 'CP Speed (Laden)',
      cpSpeedBallast: 'CP Speed (Ballast)',
      cpConsumptionLaden: 'CP Consumption (Laden)',
      cpConsumptionBallast: 'CP Consumption (Ballast)',
      note: 'Note',
      noteText:
        'This voyage will be created with status PLANNED. Operational events (e.g. Departure, COSP, EOSP) are reported on board and synchronised.',
      cancel: 'Cancel',
      create: 'Create Voyage',
      save: 'Save Voyage',
      cancelVoyage: 'Cancel Voyage',
      created: 'Voyage created.',
      saved: 'Voyage saved.',
      cancelled: 'Voyage cancelled.',
      shipOnly: 'Voyages are planned on board. The office sees them after synchronisation.',
      request: 'Send Voyage Request',
      requested: 'Voyage request sent to the vessel.',
      requestNotice:
        'The office opens a voyage by request: the vessel applies it from its own records and the voyage arrives with synchronisation (ADR 0083).',
    },
    event: {
      title: 'Leg / Event',
      description:
        'Report the operational events of the voyage: departure, sea passage, anchorage, waiting, straits, canals, cargo and hire.',
      descriptionOffice: 'Operational events reported by the vessel (read-only).',
      events: 'Events',
      log: 'Event Log',
      add: 'Add Event',
      event: 'Event',
      position: 'Position',
      noEvents: 'No events reported yet.',
      empty: 'Select an event from the log.',
      emptyShip: 'Select an event from the log or add a new one.',
      eventTime: 'Event Time',
      pdf: '{{kind}} PDF',
      timePosition: 'Time & Position',
      details: 'Event Details',
      draft: 'Draft',
      rob: 'Fuel ROB',
      addFuel: 'Add Fuel',
      removeRow: 'Remove fuel row',
      remarks: 'Remarks',
      summary: 'Since Previous Report',
      previous: 'Previous Report',
      noPrevious: 'No previous report',
      elapsed: 'Elapsed Time',
      distance: 'Distance',
      avgSpeed: 'Avg. Speed',
      saved: 'Draft saved.',
      submitted: 'Event submitted.',
      reopened: 'Event reopened.',
      removed: 'Draft deleted.',
      submit: 'Submit Event',
      submitStart: 'Submit & Start Voyage',
      remove: 'Delete Draft',
      removeTitle: 'Delete draft',
      removeBody: 'The draft is removed from the log. Its history is kept.',
      cancel: 'Cancel',
      reopenedBecause: 'Reopened: {{reason}}',
      error: 'Events could not be loaded.',
      status: {
        draft: 'Draft',
        submitted: 'Completed',
        reopened: 'Reopened',
        void: 'Void',
        new: 'New',
      },
      alerts: {
        none: 'No active alerts.',
        OPEN_PASSAGE: 'Sea passage open since {{kind}} (no EOSP yet)',
        DRAFT_PENDING: '{{kind}} not submitted',
        MISSING_POSITION: '{{kind}}: position missing',
        CRITICAL_DEFECTS: '{{count}} critical open defect(s) on board',
        UNLINKED_DEPARTURES: '{{count}} report(s) without a voyage',
      },
      categories: {
        port: 'Port',
        passage: 'Sea passage',
        anchorage: 'Anchorage / Waiting / Drift',
        straitCanal: 'Strait / Canal',
        commercial: 'Cargo and hire',
      },
      groups: {
        departure: 'Departure',
        passage: 'Leg {{leg}} · COSP → EOSP',
        passageOpen: 'Leg {{leg}} · COSP → at sea',
        arrival: 'Arrival',
      },
      searchKinds: 'Search event type',
      logTable: 'Event log table',
      distanceNm: 'Distance (NM)',
      noEventsShip: 'Add the departure report to start the voyage.',
      eventTimeLocal: 'Event Time (LT)',
      robMt: 'ROB (MT)',
      when: 'Date / Time (UTC)',
      eventPosition: 'Event / Position',
      legacyDeparture:
        'Earlier format: the event time is Pilot Off and Let Go is the last line (ADR 0058).',
      unlinkedTitle: 'No Voyage',
      unlinkedLog: 'Reports Without Voyage',
      unlinkedNote:
        'Reports entered before a voyage exists, in the order of the vessel. Start a voyage from a submitted departure, or link reports to a voyage in Voyage Details.',
      noUnlinked: 'No reports without a voyage.',
      noUnlinkedShip: 'Add a report: it can be linked to a voyage later.',
      backToVoyage: 'Back to voyage',
      unlinkedLink: 'Without voyage ({{count}})',
      amended: 'Amended',
      portCallApplied: 'Port call updated.',
      retry: 'Try again',
      fields: {
        port: 'Port',
        terminal: 'Terminal / Berth',
        allFast: 'All Fast',
        pilotOnBoard: 'Pilot On Board',
        letGo: 'Let Go / Cast Off',
        tugsUsed: 'Number of Tugs Used',
        tugDetails: 'Tug Names / Details',
        underway: 'Vessel Underway',
        course: 'Course',
        rpm: 'RPM',
        speedKn: 'Speed',
        loadCondition: 'Load Condition',
        distanceSinceLast: 'Distance Since Last Report',
        consumptionMt: 'Daily Consumption',
        reason: 'Reason',
        name: 'Name',
        operation: 'Operation',
        charterPartyNo: 'Charter Party No',
        firstLine: 'First Line',
        fwdM: 'Draft FWD',
        aftM: 'Draft AFT',
        fuel: 'Fuel',
        rob: 'ROB',
        pilotOff: 'Pilot Off',
        berthSide: 'Port / Starboard Side',
        distanceToShoreM: 'Distance to Shore',
        distanceToPortNm: 'Distance to Port',
      },
      options: {
        reasons: {
          waiting_for_charter: 'Waiting for charter',
          waiting_for_berth: 'Waiting for berth',
          waiting_for_orders: 'Waiting for orders',
          weather: 'Weather',
          traffic: 'Traffic',
          port_congestion: 'Port congestion',
          other: 'Other',
        },
        loadConditions: { laden: 'Laden', ballast: 'Ballast' },
        cargoOperations: { loading: 'Loading', discharging: 'Discharging' },
        berthSides: { port: 'Port side', starboard: 'Starboard side' },
      },
    },
    performance: {
      title: 'Voyage Performance',
      description:
        'Overall voyage, charter party window and strait/canal segments, calculated from submitted reports.',
      voyage: 'Voyage',
      started: 'Voyage Start',
      ended: 'Voyage End',
      overallDistance: 'Overall Distance',
      overallTime: 'Overall Time',
      overallSpeed: 'Overall Avg. Speed',
      cpDistance: 'CP Distance',
      cpTime: 'CP Time',
      cpSpeed: 'CP Avg. Speed',
      segments: 'Performance Segments',
      noSegments: 'No performance data yet: it starts with the submitted departure report.',
      segment: 'Segment',
      period: 'Period (UTC)',
      hours: 'Hours',
      avgSpeed: 'Avg. Speed (kn)',
      cpRule: 'CP Treatment',
      overall: 'Overall Voyage',
      cpWindow: 'CP Window (COSP → EOSP)',
      strait: 'Strait',
      canal: 'Canal',
      ongoing: 'Ongoing',
      allIncluded: 'All operations included',
      excluded: '{{value}} h excluded',
      notInCp: 'Excluded from CP',
      rules:
        'CP performance covers COSP → EOSP only; straits, canals, anchorage, drifting and waiting are excluded. Overall covers voyage start → end.',
      speedByReport: 'Speed by Report',
      noSpeeds: 'No reports with distance yet.',
      avgSpeedLegend: 'Avg. speed since previous report',
      cpSpeedLegend: 'CP speed {{value}} kn',
      legs: 'Report Legs',
      hoursSince: 'Hours Since Previous',
      startedUtc: 'Voyage Start (UTC)',
      endedUtc: 'Voyage End (UTC)',
      cpWindowN: 'CP Window {{n}} (COSP → EOSP)',
      cpTotal: 'CP Total',
      noExclusions: 'No exclusions',
      segmentsTable: 'Performance segments table',
      legsTable: 'Report legs table',
      vsCp: 'vs. CP',
      legCp: { in: 'In CP', below: 'Below CP', outside: 'Outside window' },
      belowCpLegend: 'Below CP speed',
      outsideLegend: 'Outside CP window',
      chartSummary:
        'Average speed of {{count}} report legs between {{min}} and {{max}} kn; CP speed {{cp}} kn; {{below}} legs in the CP window below CP speed.',
    },
    charterParty: {
      title: 'Charter Party Performance',
      description:
        'Charter party terms and the COSP → EOSP performance compared with them; noon reports checked against the CP weather limits.',
      terms: 'Charter Party Terms',
      speedLadenBallast: 'CP Speed (Laden / Ballast)',
      consumptionLadenBallast: 'CP Consumption (Laden / Ballast)',
      weatherLimit: 'CP Weather Limit',
      weatherLimitValue: 'Beaufort ≤ {{beaufort}}, wave ≤ {{height}} m',
      fuel: 'Fuel (ME / AE)',
      window: 'CP Window',
      cosp: 'COSP',
      eosp: 'EOSP',
      open: 'Open (no EOSP yet)',
      windowHours: 'Window',
      excludedHours: 'Excluded (strait, canal, anchorage …)',
      performanceHours: 'Performance Time',
      distance: 'Performance Distance',
      loadCondition: 'Load Condition',
      noWindow: 'Submit the COSP report: the CP window starts with it.',
      status: 'CP Status',
      compliance: 'Speed compliance (good weather)',
      dailyConsumption: 'Daily Consumption',
      goodWeatherDays: 'Good Weather Days',
      goodBasis: '{{days}} days · {{hours}} h · {{distance}} NM',
      noGoodDays: 'No good weather days yet: the CP evaluation needs at least one.',
      wholePeriod: 'Whole CP Period',
      rule: 'Evaluated on good weather days: speed = distance / time and daily consumption = consumption / time × 24 on those days. Within the charter party: speed not below and daily consumption not above the CP values (no tolerance applied). The whole CP period is shown for reference.',
      days: 'Noon Reports in CP Window',
      goodDays: '{{good}} of {{total}} days within CP weather',
      noDays: 'No submitted noon reports in the CP window yet.',
      vsCp: 'vs. CP',
      below: 'Below',
      beaufort: 'Beaufort',
      seaState: 'Sea State',
      swellHeight: 'Swell (m)',
      waveHeight: 'Hs (m)',
      goodWeather: 'Good Weather',
      yes: 'Yes',
      no: 'No',
      unknown: 'Unknown',
      excludedDay: 'Excluded',
      comparison: 'CP Comparison',
      goodWeatherTable: 'Good weather days compared with the charter party',
      wholeTable: 'Whole CP period compared with the charter party',
      daysTable: 'Noon reports in the CP window',
      when: 'Date / Time (UTC)',
      hours: 'Hours',
      excludedShort: 'Excluded',
      windowCount: 'CP Windows',
      excludedHint: 'Straits, canals, anchorage, drifting and waiting inside the CP window.',
      noWindowTitle: 'No CP window yet',
      beaufortLimit: 'Beaufort ≤ {{value}}',
      waveLimit: 'Hs ≤ {{value}} m',
      weatherNoteLabel: 'How a good weather day is decided',
      pagination: 'Noon report pages',
      page: {
        first: 'First page',
        previous: 'Previous page',
        next: 'Next page',
        last: 'Last page',
        number: 'Page {{page}}',
      },
      goodVerdict: {
        within: 'Good weather: within CP',
        outside: 'Good weather: outside CP',
        partial: 'Good weather: partial',
        unknown: 'Good weather: not evaluated',
      },
      wholeVerdict: {
        within: 'Whole period: within CP',
        outside: 'Whole period: outside CP',
        partial: 'Whole period: partial',
        unknown: 'Whole period: not evaluated',
      },
      verdictText: {
        within: 'Within charter party limits on good weather days.',
        outside: 'Outside charter party limits on good weather days.',
        partial: 'Speed within CP · consumption n/a: the consumption cannot be evaluated yet.',
        unknown: 'Not evaluated yet: no good weather days with speed and consumption.',
      },
      weatherNote:
        'Good weather day: Beaufort and significant wave height (Hs) within the CP limits. Hs = √(wind sea² + swell²); wind sea is the upper bound of the Douglas sea state (sea state 9 exceeds every limit). A day without Beaufort, sea state or swell is not counted; a report ending in a strait, canal, anchorage, drift or waiting period is excluded.',
    },
    // Düzenle ve sil (ADR 0077): taslaktan vazgeçme, gerekçeli iptal, seferin silinmesi
    withdraw: {
      removeDraft: 'Delete Draft',
      removeTitle: 'Delete draft',
      removeBody:
        'The draft is removed from the log; the change stays in the history. Only the latest report of the voyage can be deleted.',
      removed: 'Draft deleted.',
      voidReport: 'Void Report',
      voided: 'Report voided. It stays in the history marked Void.',
      notLast:
        'Only the latest report of the voyage can be deleted or voided. Remove or void the later reports first.',
      reopenMasterOnly:
        'Submitted reports are locked. To correct one, the master uses Edit (reopen) with a reason; the corrected report is submitted again as a new revision.',
      voidedTitle: 'Void',
      voidedBecause: 'Reason: {{reason}} · {{at}} (UTC)',
      voyageTitle: 'Delete voyage',
      voyageDeleteHint:
        'This voyage has no reports. Deleting removes it from the lists; the history is kept.',
      voyageVoidHint:
        'This voyage has {{count}} report(s), so it cannot be deleted. Void it with a reason: the voyage and its reports stay in the history marked Void.',
      deleteVoyage: 'Delete Voyage',
      voidVoyage: 'Void Voyage',
      deleteVoyageTitle: 'Delete voyage {{no}}?',
      deleteVoyageBody:
        'The voyage is removed from the lists. A departure that started it returns to the departures without voyage. The history is kept.',
      voyageVoidedTitle: 'Voyage voided',
    },
    voidDialog: {
      reason: 'Reason',
      password: 'Password',
      cancel: 'Cancel',
      report: {
        title: 'Void report',
        lead: 'The report is not deleted.',
        body: 'It stays in the history marked Void and no longer counts in the voyage calculations or the report sequence. This cannot be undone. To correct a report instead, use Edit (reopen).',
        confirm: 'Void Report',
      },
      voyage: {
        title: 'Void voyage',
        lead: 'The voyage is not deleted.',
        body: 'It is shown as Void with your reason and its reports stay in the history. No new reports can be added and the voyage can no longer be edited. This cannot be undone.',
        confirm: 'Void Voyage',
      },
    },
    errors: {
      REQUIRED: 'Required',
      OUT_OF_RANGE: 'Out of range',
      NOT_INTEGER: 'Must be a whole number',
      INVALID_NUMBER: 'Enter a number',
      INVALID_DATETIME: 'Invalid date and time',
      INVALID_TZ_OFFSET: 'Invalid UTC offset',
      INVALID_OPTION: 'Select from the list',
      TOO_LONG: 'Too long',
      DUPLICATE: 'Duplicate row',
      TIME_ORDER: 'Time is out of order',
      // Sıra hatası hangi zamana göre (ortak geri bildirimi 2026-10-19)
      TIME_ORDER_AFTER: 'Must be after {{ref}} ({{time}} LT). Check both times.',
      TIME_ORDER_BEFORE: 'Must be before {{ref}} ({{time}} LT). Check both times.',
      timeRefs: {
        reportedAt: 'the report time',
        castOff: 'Cast Off',
        pilotOnBoard: 'Pilot On Board',
        firstLine: 'First Line',
        allFast: 'All Fast',
        letGo: 'Let Go',
        tenderedAt: 'NOR Tendered',
        alongside: 'Tug Alongside',
      },
      SUMMARY_one: 'Not saved: {{count}} field needs attention: {{sections}}.',
      SUMMARY_other: 'Not saved: {{count}} fields need attention: {{sections}}.',
      SUMMARY_OTHER_FIELDS: 'other fields',
      INVALID_POSITION: "Use the format 34° 45.6' N",
      FUTURE_DATE: 'The report time cannot be in the future (ship server clock).',
      REPORT_SUBMITTED: 'The report has already been submitted and is locked.',
      ALREADY_SUBMITTED: 'The report has already been submitted.',
      CONTENT_CHANGED: 'The report changed on the server. Reload and try again.',
      ROW_VERSION_CONFLICT: 'Someone else changed this report. Reload and try again.',
      INVALID_CREDENTIALS: 'Password is incorrect.',
      TOO_MANY_ATTEMPTS: 'Too many attempts. Try again later.',
      REOPEN_REASON_REQUIRED: 'Enter a reason.',
      FORBIDDEN: 'You are not authorised for this action.',
      VOYAGE_UNKNOWN: 'The voyage is not on this vessel.',
      VOYAGE_CANCELLED: 'The voyage has been cancelled.',
      SEQUENCE_NOT_AT_SEA: 'A noon report needs an open sea passage (COSP before it, no EOSP).',
      SEQUENCE_BEFORE_DEPARTURE: 'The report is before the departure of the voyage.',
      SEQUENCE_DUPLICATE_DEPARTURE:
        'A departure must be the first report of the voyage or follow a berthing report (each port has its own departure).',
      SEQUENCE_ALREADY_OPEN: 'This period is already open; close it first.',
      SEQUENCE_NOT_OPEN: 'There is no open period to close (start report missing).',
      SEQUENCE_NAME_MISMATCH: 'The exit name does not match the entry.',
      SEQUENCE_NOT_AT_ANCHOR: 'A daily anchorage report needs the vessel at anchor.',
      SEQUENCE_NOT_AT_BERTH:
        'A port daily report needs the vessel at berth (after the berthing report, before the departure).',
      SEQUENCE_NOT_DRIFTING: 'A drift daily report needs the vessel drifting (after drift start).',
      SEQUENCE_NEXT_OPERATION:
        'This report does not match the Next Operation chosen in the previous report. Choose the report it leads to, or ask the Master to reopen the previous report and change its Next Operation.',
      NEXT_OPERATION_REQUIRED: 'Choose the Next Operation before submitting.',
      VESSEL_MISMATCH: 'The voyage belongs to another vessel.',
      DUPLICATE_VOYAGE_NO: 'This voyage number is already used.',
      VOYAGE_STARTED:
        'This voyage has reports, so it cannot be deleted. Void it with a reason instead.',
      INVALID_VOYAGE: 'Some fields are invalid.',
      UNKNOWN_PORT: 'The port is not in the port list.',
      INVALID_PORT_CODE: 'The port code is invalid.',
      INVALID_VOYAGE_REPORT: 'Some fields are invalid.',
      VOYAGE_REQUIRED: 'Only a departure can be entered without a voyage.',
      VOYAGE_ACTION_MISMATCH: 'The voyage decision does not match the voyage link.',
      DEPARTURE_UNKNOWN: 'The departure report is not on this vessel.',
      DEPARTURE_LINKED: 'This departure is already linked to a voyage.',
      REPORT_LINKED: 'This report is already linked to a voyage. Unlink it first.',
      REPORT_HAS_VOYAGE:
        'This report was entered for a voyage; only reports without a voyage are linked.',
      VOYAGE_OVERLAP:
        'Voyages cannot overlap in time: this report lies within another voyage. Link it to that voyage or unlink the other reports first.',
      LINK_NOT_FOUND: 'This report is not linked to the voyage.',
      REQUEST_DECIDED: 'This request has already been decided.',
      INVALID_VOYAGE_REQUEST: 'The voyage request is incomplete.',
      DEPARTURE_NOT_SUBMITTED: 'Submit the departure report before starting the voyage with it.',
      LINK_UNKNOWN: 'A linked record (port call, checklist or defect) is not on this vessel.',
      NO_PORT_CALL: 'The report is not linked to a port call.',
      MISMATCH: 'Does not match the rows entered',
      CONFLICT: 'Remove the pilot times or untick N/A',
      NOT_ALLOWED: 'Not allowed with this selection',
      EXCEEDS_TOTAL: 'Cannot be more than the total',
      INVALID_ID: 'Invalid link',
      NOT_FINAL: 'Submit the report first.',
      // Düzenle ve sil (ADR 0077)
      REPORT_NOT_LAST:
        'Only the latest report of the voyage can be deleted or voided. Remove or void the later reports first.',
      REPORT_VOIDED: 'The report has been voided and is locked.',
      VOYAGE_VOIDED: 'The voyage has been voided; it cannot be changed.',
      VOID_REASON_REQUIRED: 'Enter a reason.',
      ALREADY_VOIDED: 'Already voided.',
      RECORD_NOT_SUBMITTED: 'A draft is deleted, not voided.',
      REAUTHENTICATION_REQUIRED: 'Enter your password.',
      GENERIC: 'The operation failed. Try again.',
    },
  },
  materials: materialsEn,
  stock: stockEn,
  purchasing: purchasingEn,
  purchasingMarket: purchasingMarketEn,
  // Tedarikçi kartında profil ve banka (ADR 0114)
  supplierProfile: supplierProfileEn,
  supplierAccount: supplierAccountEn,
  // Tedarikçi carisi ve belge isteğinin e-postaları (ADR 0119 Ek 2026-10-24)
  supplierNotices: supplierNoticesEn,
  // Gemiye nihai liste ve mal kabulü (ADR 0115)
  purchasingShip: purchasingShipEn,
  // Limanlar ve mesafeler (M13b; ADR 0048)
  ports: portsEn,
  // Risk değerlendirmesi (M13d; ADR 0050)
  risk: riskEn,
  riskMaster: riskMasterEn,
  riskLibrary: riskLibraryEn,
  riskRegister: riskRegisterEn,
  riskDashboard: riskDashboardEn,
  riskVerification: riskVerificationEn,
  // Findings & Actions (K6; ADR 0094)
  riskFindings: riskFindingsEn,
  // Mürettebat bordrosu (M16; ADR 0061)
  payroll: payrollEn,
  // Kaptan kasası ve Cash to Master (ADR 0093)
  cash: cashEn,
  // Kumanya (ADR 0099)
  provisions: provisionsEn,
  // Aylık iaşe raporu (ADR 0123)
  victualling: victuallingEn,
  // Yakıt yönetimi (ADR 0117)
  fuel: fuelEn,
  shipClock: shipClockEn,
  portCalls: { ...portCallsEn, pdf: portCallPdfEn },
  reports: reportsEn,
  pmsReports: pmsReportsEn,
  pmsAudit: pmsAuditEn,
  settingsScreen: settingsEn,
  // Felixmate Office Pack (ADR 0070)
  officePack: officePackEn,
  // Ek önizlemesi (ortak 2026-10-24 madde 4; ADR 0126)
  attachmentPreview: attachmentPreviewEn,
  // Sayfa bilgi penceresi ("i"; ADR 0053): pencere metinleri ve menü öğesi başına içerik
  pageHelp: pageHelpEn,
  help: helpEn,
  // Şirket kurulumu (ADR 0042 §22–§24; M8b4)
  setup: setupEn,
  // Doküman kütüphanesi (M8a3)
  documents: documentsEn,
  // ISM form kayıtları (ADR 0042; M8b3)
  forms: formsEn,
  // İade ve ret bildirimi, diğer onay akışları (ADR 0116 Ek)
  masterSection: masterSectionEn,
  returned: returnedEn,
  // Panoda bana düşen işler (ADR 0156)
  tasks: tasksEn,
  pms: pmsEn,
  daily: dailyEn,
  // Compliance ▸ Vessel Certificates (M7d)
  vesselCertificates: vesselCertificatesEn,
  // Arıza DM-17 (ADR 0060)
  defects: defectsEn,
  hse: {
    ...hseEn,
    ...hseExtraEn,
    // Şirket uygunsuzluğu kodları HSE pencerelerinde de çözülür; HSE metni önceliklidir
    errors: { ...companyNcEn.errors, ...hseEn.errors },
  },
  // Ofisin şirket uygunsuzluğu ve ortak kayıt PDF'i (ADR 0062)
  companyNc: companyNcEn,
  recordPdf: recordPdfEn,
  pmsLibrary: pmsLibraryEn,
  classIntegration: classIntegrationEn,
  // Tatbikat yönetimi (ADR 0128)
  drills: drillsEn,
  drydock: drydockEn,
  // Dry dock raporları, denetim izi ve filo görünümü (ADR 0129 Ek Faz 5)
  drydockReport: drydockReportEn,
  drydockAudit: drydockAuditEn,
  drydockFleet: drydockFleetEn,
  drillPlan: drillPlanEn,
  drillRecord: drillRecordEn,
  drillFinding: drillFindingEn,
  drillReport: drillReportEn,
  // Crew List (IMO FAL Form 5; ADR 0130 §B)
  crewList: crewListEn,
  // Personel kartı (ADR 0131)
  crewProfile: crewProfileEn,
  // Crew Profile ▸ Office notes (ADR 0159)
  crewNotes: crewNotesEn,
  // Crew ▸ Login Accounts (ADR 0147)
  loginAccounts: loginAccountsEn,
  signOnOff: signOnOffEn,
  // Bağlı test ortamı hesapları (ADR 0092)
  testAccounts: testAccountsEn,
  stages: {
    M7: 'M7 — Planned maintenance',
    M8a: 'M8a — Document library and ISM forms',
    M8b: 'M8b — Filled ISM forms and approvals',
    M10d: 'M10d — Hours of rest on board',
    M11: 'M11 — Voyage and Noon Report',
    M12a: 'M12a — Material catalogue and stock',
    M12b: 'M12b — Requisitions and RFQ',
    M12c: 'M12c — Purchase orders and GRN',
    phase2: 'Phase 2',
    phase3: 'Phase 3',
    V2: 'V2 — Voyage events, summary and timeline',
    V6: 'V6 — Fuel and consumption analysis',
    withModules: 'with each module',
    nextUpdate: 'the next update of the vessel app',
    office: 'the office (web)',
  },
};

export type UiResources = typeof en;
